import {
  FETCH_START,
  FETCH_END,
  PROMOTION_DATA_SUCCESS,
  PROMO_FINANCE_COST_DATA_SUCCESS,
  FINANCE_TERM_SPLIT_DATA_SUCCESS,
  FINANCE_GROUP_RATES_DATA_SUCCESS,
  PROMO_TERRITORY_DATA_SUCCESS,
  PROMO_TERRITORY_FORMAT_SUCCESS,
  PROMO_TERRITORY_FORMAT_BY_ID_SUCCESS,
  PROMO_TERRITORY_FORMAT_FIELDS_SUCCESS,
  PROMO_TERRITORY_UPLOAD_SUCCESS,
  PROMO_FINANCE_COST_DETAIL_SUCCESS,
  PROMO_FINANCE_TERM_SPLIT_DETAIL_SUCCESS,
  PROMO_FINANCE_GROUP_RATES_DETAIL_SUCCESS,
  FINANCE_COST_FORMAT_SUCCESS,
  FINANCE_COST_FORMAT_BY_ID_SUCCESS,
  FINANCE_COST_FORMAT_FIELDS_SUCCESS,
  PROMO_FINANCE_COST_UPLOAD_SUCCESS,
  FINANCE_TERM_SPLIT_FORMAT_SUCCESS,
  FINANCE_GROUP_RATE_FORMAT_SUCCESS,
  FINANCE_TERM_SPLIT_FORMAT_FIELDS_SUCCESS,
  FINANCE_GROUP_RATES_FORMAT_FIELDS_SUCCESS,
  PROMO_FINANCE_TERM_SPLIT_UPLOAD_SUCCESS,
  PROMO_FINANCE_GROUP_RATE_UPLOAD_SUCCESS,
  COUNTRY_SUCCESS,
  TERRITORY_ID_SUCCESS,
  PROMO_MAP_SUCCESS,
  PROMO_MAP_SINGLE_SUCCESS,
  PROMO_MAPPING_FORMAT_SUCCESS,
  PROMO_MAP_FORMAT_BY_ID,
  PROMO_MAP_FORMAT_FIELDS,
  PROMO_TYPES,
  PROMO_STICKERS,
  PROMO_STICKER_BY_ID,
  CLEAR_PROMO_STICKER_BY_ID,
  PROMO_FILTERS,
  MARKET_FILTERS,
  MODEL_GROUP,
  LOCATION_GROUP,
  MODEL_LIST_GROUP,
  PROMO_CONFIG_UPLOAD_SUCCESS,
  PROMO_CONFIG_FORMAT_FIELDS_SUCCESS,
  PROMO_CONFIG_FORMAT_SUCCESS,
  PROMO_CONFIG_DATA_SUCCESS,
  MATERIAL_PRICING_UPLOAD_SUCCESS,
  MATERIAL_PRICING_FORMAT_FIELDS_SUCCESS,
  MATERIAL_PRICING_FORMAT_SUCCESS,
  MATERIAL_PRICING_DATA_SUCCESS,
  MATERIAL_PRICING_SINGLE_DATA_SUCCESS,
  PROMO_CONFIG_SINGLE_DATA_SUCCESS,
  SCENARIO_LIST_DATA_SUCCESS,
  SAND_BOX_DATA_SUCCESS,
  HISTORY_DATA_SUCCESS,
  PROMOTIONS_SEARCH_SUCCESS,
  COSTING_START,
  COSTING_END,
  PREFILL_SCENARIO_SUCCESS,
  SCENARIO_BY_ID,
  COVERAGE_MAPPING_UPLOAD_SUCCESS,
  COVERAGE_MAPPING_FORMAT_FIELDS_SUCCESS,
  COVERAGE_MAPPING_FORMAT_SUCCESS,
  COVERAGE_MAPPING_DATA_SUCCESS,
  COVERAGE_MAPPING_SINGLE_SUCCESS,
  STANDARD_FINANCE_UPLOAD_SUCCESS,
  STANDARD_FINANCE_FORMAT_FIELDS_SUCCESS,
  STANDARD_FINANCE_FORMAT_SUCCESS,
  STANDARD_FINANCE_DATA_SUCCESS,
  STANDARD_FINANCE_SINGLE_DATA_SUCCESS,
  PROMOTION_CURRENCY_UPLOAD_SUCCESS,
  PROMOTION_CURRENCY_FORMAT_FIELDS_SUCCESS,
  PROMOTION_CURRENCY_FORMAT_SUCCESS,
  PROMOTION_CURRENCY_DATA_SUCCESS,
  PROMOTION_CURRENCY_SINGLE_SUCCESS,
  SAVED_SCENARIO,
  SALES_FORECAST_SINGLE_DATA_SUCCESS,
  SCENARIO_MARKETS,
  PREVIOUS_SCENARIO,
  REVIEW_SCENARIO,
  CURRENT_SCENARIO,
  MARKET_END,
  MARKET_START,
  CUSTOM_GROUP_ID,
  CUSTOM_GROUPS,
  CUSTOM_GROUP_LIST,
  TR_APPROVAL_REVIEW_DATA_SUCCESS,
  TR_APPROVAL_DATA_SUCCESS,
  MULTI_PROMO_SEARCH_SUCCESS,
  TR_APPROVAL_REVIEW_COMPLETED_DATA_SUCCESS,
  GROUPED_CUSTOM_GROUP,
  PROMOTION_COSTING_COMPARISON_UPLOAD_SUCCESS,
  PROMO_COSTING_DROPDOWN_DATA_SUCCESS,
  ARCHIVE,
  STICKER_ARCHIVE,
  PROMO_COSTING_TABLE_DATA_SUCCESS,
  LOCATION_FILTER,
  SCENARIO_DATA,
  GRID_DATA,
  USER_ACCESS_DATA,
  CURRENT_MODEL_YEAR,
  PROMO_FINANCE_COSTING_DIALOG_DATA_SUCCESS,
  PROMO_PROMOTIONAL_OFFERS_DATA_SUCCESS,
  PROMO_REGULAR_OFFERS_DATA_SUCCESS,
  PROMO_REGULAR_OFFERS_FORMAT_SUCCESS,
  PROMO_REGULAR_OFFERS_UPLOAD_SUCCESS,
  PROMO_REGULAR_OFFERS_FIELDS_SUCCESS,
  PROMO_REGULAR_FINANCING_DATA_SUCCESS,
  DOWNLOADING, VALID_MARKETS,
  PROMO_COMMENT_DIALOG_DATA_SUCCESS,
  HISTORY_UPLOAD_SUCCESS,
  MANUAL_PROMO_SUCCESS,
  MANUAL_FIELD_SUCCESS,
  MANUAL_UPLOAD_FORMAT_DATA,
  MANUAL_UPLOAD_FORMAT_UPDATE_OR_DELETE,
  MANUAL_PROMO_BY_ID, PROMO_COSTING_ANALYSIS_DATA_SUCCESS,
  PROMO_FIN_EXCEPTION_SCENARIO_SUCCESS,
  PROMO_BUDGET_DATA_SUCCESS, TEMP_PROMO_BUDGET_DATA_SUCCESS,
  BUDGET_LIST_DATA_SUCCESS,
  BUDGET_STICKER_CLONED_DATA, BUDGET_VOLUME_DATA_SUCCESS,
  BUDGET_SALES_FORECAST_DATA_SUCCESS,
  BUDGET_SALES_FORECAST_SINGLE_DATA_SUCCESS,
  BUDGET_PREFILL_LIST_DATA_SUCCESS,
  PROMO_BUDGET_PREFILL_DATA_SUCCESS,
  BUDGET_REPORTING_DATA_SUCCESS,
  APPROVED_SCENARIO_LIST_SUCCESS,
  PROMO_SIGNATURE_CONFIG_LIST_SUCCESS,
  PROMO_SIGNATURE_CONFIG_BY_ID_SUCCESS,
  PROMO_MATERIAL_MASTER_DETAIL_SUCCESS,
} from './ActionTypes';
import secureLocalStorage from 'react-secure-storage';
import axios from '../../../axios.conf';
import { toast } from 'react-toastify';
import { history } from '../../../components/Helpers';

export const fetchStart = () => {
  return {
    type: FETCH_START,
  };
};

export const fetchEnd = () => {
  return {
    type: FETCH_END,
  };
};

export const getCreatePromotionPlanSuccess = (data) => {
  return {
    type: PROMOTION_DATA_SUCCESS,
    data,
  };
};

export const createPromotionPlan = (data) => {
  return (dispatch) => {
    dispatch(fetchStart());
    getCreatePromotionPlanAPI(data)
      .then((response) => {
        dispatch(fetchEnd());
        dispatch(getCreatePromotionPlanSuccess(response.data.response));
        history.push('/promotion-trends-results');
      })
      .catch((error) => {
        dispatch(fetchEnd());
      });
  };
};

const getCreatePromotionPlanAPI = (data) => {
  const headers = {
    Authorization: secureLocalStorage.getItem('aTk'),
  };
  var result;
  result = axios.post('plan-promotions', data, { headers: headers });
  return result;
};

//save
export const savePromotionPlan = (data) => {
  return (dispatch) => {
    getSavePromotionPlanAPI(data)
      .then((response) => {
        toast.success(response.data.response);
        history.push('/promotion-trends');
      })
      .catch((error) => {
        //toast.error(error.response.data.complete_error_message)
      });
  };
};

const getSavePromotionPlanAPI = (data) => {
  const headers = {
    Authorization: secureLocalStorage.getItem('aTk'),
  };
  var result;
  result = axios.post('/plan-promotions-save', data, { headers: headers });
  return result;
};

// //   Promo Finance Cost
export const getPromoFinanceCostData = () => {
  return (dispatch) => {
    dispatch(fetchStart());
    getPromoFinanceCostDataApi()
      .then((response) => {
        dispatch(fetchEnd());
        dispatch(getPromoFinanceCostDataSuccess(response.data.response));
      })
      .catch((error) => {
        dispatch(fetchEnd());
      });
  };
};

const getPromoFinanceCostDataApi = () => {
  const headers = {
    Authorization: secureLocalStorage.getItem('aTk'),
  };
  var result;
  result = axios.get('promo-finance-cost?page=1&&limit=0', {
    headers: headers,
  });
  return result;
};

export const getPromoFinanceCostDataSuccess = (data) => {
  return {
    type: PROMO_FINANCE_COST_DATA_SUCCESS,
    data,
  };
};
export const deleteFinanceCostData = (id) => {
  return (dispatch) => {
    deleteFinanceCostDataApi(id).then((response) => {
      toast.success(response.data.response);
      dispatch(getPromoFinanceCostData());
    });
  };
};
const deleteFinanceCostDataApi = (id) => {
  const headers = {
    Authorization: secureLocalStorage.getItem('aTk'),
  };
  var result;
  result = axios.delete('promo-finance-cost/' + id, { headers: headers });
  return result;
};
// delete promo finance group rates
export const deleteFinanceGroupRatesData = (id) => {
  return (dispatch) => {
    deleteFinanceGroupRatesDataApi(id).then((response) => {
      toast.success(response.data.response);
      dispatch(getFinanceGroupRatesData());
    });
  };
};
const deleteFinanceGroupRatesDataApi = (id) => {
  const headers = {
    Authorization: secureLocalStorage.getItem('aTk'),
  };
  var result;
  result = axios.delete('promotion/pf-anchor-rates/' + id, { headers: headers });
  return result;
};
// delete promo finance term split
export const deleteFinanceTermSplitData = (id) => {
  return (dispatch) => {
    deleteFinanceTermSplitDataApi(id).then((response) => {
      toast.success(response.data.response);
      dispatch(getFinanceTermSplitData());
    });
  };
};
const deleteFinanceTermSplitDataApi = (id) => {
  const headers = {
    Authorization: secureLocalStorage.getItem('aTk'),
  };
  var result;
  result = axios.delete('promotion/pf-anchor-splits/' + id, { headers: headers });
  return result;
};


// finance group rates

export const getFinanceGroupRatesData = () => {
  return (dispatch) => {
    dispatch(fetchStart());
    getFinanceGroupRatesDataApi()
      .then((response) => {
        dispatch(fetchEnd());
        dispatch(getFinanceGroupRatesDataSuccess(response.data.response));
      })
      .catch((error) => {
        dispatch(fetchEnd());
      });
  };
};

const getFinanceGroupRatesDataApi = () => {
  const headers = {
    Authorization: secureLocalStorage.getItem('aTk'),
  };
  var result;
  result = axios.get('promotion/pf-anchor-rates', {
    headers: headers,
  });
  return result;
};

export const getFinanceGroupRatesDataSuccess = (data) => {
  return {
    type: FINANCE_GROUP_RATES_DATA_SUCCESS,
    data,
  };
};

export const addFinanceGroupRatesData = (data) => {
  return (dispatch) => {
    dispatch(fetchStart());
    addFinanceGroupRatesDataApi(data)
      .then((response) => {
        toast.success('Successfully added.');
        dispatch(fetchEnd());
        dispatch(getFinanceGroupRatesData());
        history.push('/finance-group-rates');
      })
      .catch((error) => {
        dispatch(fetchEnd());
        const message =
          error?.response?.data?.response ||
          error?.response?.data?.error ||
          'Failed to add Finance Group Rates.';
        toast.error(message);
      });
  };
};

const addFinanceGroupRatesDataApi = (data) => {
  const headers = {
    Authorization: secureLocalStorage.getItem('aTk'),
  };
  return axios.post('/promotion/pf-anchor-rates', data, { headers });
};


// Finance Term Split 
export const getFinanceTermSplitData = () => {
  return (dispatch) => {
    dispatch(fetchStart());
    getFinanceTermSplitDataApi()
      .then((response) => {
        dispatch(fetchEnd());
        dispatch(getFinanceTermSplitDataSuccess(response.data.response));
      })
      .catch((error) => {
        dispatch(fetchEnd());
      });
  };
};

const getFinanceTermSplitDataApi = () => {
  const headers = {
    Authorization: secureLocalStorage.getItem('aTk'),
  };
  var result;
  result = axios.get('promotion/pf-anchor-splits', {
    headers: headers,
  });
  return result;
};

export const getFinanceTermSplitDataSuccess = (data) => {
  return {
    type: FINANCE_TERM_SPLIT_DATA_SUCCESS,
    data,
  };
};

export const addFinanceTermSplitData = (data) => {
  return (dispatch) => {
    dispatch(fetchStart());
    addFinanceTermSplitDataApi(data)
      .then((response) => {
        toast.success('Successfully added.');
        dispatch(fetchEnd());
        dispatch(getFinanceTermSplitData());
        history.push('/finance-term-split');
      })
      .catch((error) => {
        dispatch(fetchEnd());
        const message =
          error?.response?.data?.response ||
          error?.response?.data?.error ||
          'Failed to add Finance Term Split.';
        toast.error(message);
      });
  };
};

const addFinanceTermSplitDataApi = (data) => {
  const headers = {
    Authorization: secureLocalStorage.getItem('aTk'),
  };
  return axios.post('promotion/pf-anchor-splits', data, { headers });
};
// get Finance group rates format
export const getFinanceGroupRateFormatData = () => {
  return (dispatch) => {
    getFinanceGroupRateFormatDataApi()
      .then((response) => {
        dispatch(getFinanceGroupRateFormatDataSuccess(response.data.response));
      })
      .catch((error) => {
      });
  };
};

const getFinanceGroupRateFormatDataApi = () => {
  const headers = {
    Authorization: secureLocalStorage.getItem('aTk'),
  };
  var result;
  result = axios.get(
    'upload-format?app-functionality=PromotionPfAnchorRateFormat',
    { headers: headers },
  );
  return result;
};

export const getFinanceGroupRateFormatDataSuccess = (data) => {
  return {
    type: FINANCE_GROUP_RATE_FORMAT_SUCCESS,
    data,
  };
};

// Finance Term Split format
export const getFinanceTermSplitFormatData = () => {
  return (dispatch) => {
    getFinanceTermSplitFormatDataApi()
      .then((response) => {
        dispatch(getFinanceTermSplitFormatDataSuccess(response.data.response));
      })
      .catch((error) => {
      });
  };
};

const getFinanceTermSplitFormatDataApi = () => {
  const headers = {
    Authorization: secureLocalStorage.getItem('aTk'),
  };
  var result;
  result = axios.get(
    'upload-format?app-functionality=PromotionPfAnchorSplitFormat',
    { headers: headers },
  );
  return result;
};

export const getFinanceTermSplitFormatDataSuccess = (data) => {
  return {
    type: FINANCE_TERM_SPLIT_FORMAT_SUCCESS,
    data,
  };
};

// Finance Cost format
export const getFinanceCostFormatData = () => {
  return (dispatch) => {
    getFinanceCostFormatDataApi()
      .then((response) => {
        dispatch(getFinanceCostFormatDataSuccess(response.data.response));
      })
      .catch((error) => {
        //toast.error(error.response.data.error.message);
      });
  };
};

const getFinanceCostFormatDataApi = () => {
  const headers = {
    Authorization: secureLocalStorage.getItem('aTk'),
  };
  var result;
  result = axios.get(
    'upload-format?app-functionality=PromotionPromoFinanceCostsFormat',
    { headers: headers },
  );
  return result;
};

export const getFinanceCostFormatDataSuccess = (data) => {
  return {
    type: FINANCE_COST_FORMAT_SUCCESS,
    data,
  };
};

export const getFinanceCostFormatDataById = (id) => {
  return (dispatch) => {
    getFinanceCostFormatDataByIdApi(id)
      .then((response) => {
        dispatch(getFinanceCostFormatDataByIdSuccess(response.data.response));
      })
      .catch((error) => {
        //toast.error(error.response.data.error.message);
      });
  };
};

const getFinanceCostFormatDataByIdApi = (id) => {
  const headers = {
    Authorization: secureLocalStorage.getItem('aTk'),
  };
  var result;
  result = axios.get(
    'upload-format/' +
    id +
    '?app-functionality=PromotionPromoFinanceCostsFormat',
    { headers: headers },
  );
  return result;
};

export const getFinanceCostFormatDataByIdSuccess = (data) => {
  return {
    type: FINANCE_COST_FORMAT_BY_ID_SUCCESS,
    data,
  };
};

//get Finance Cost format fields
export const getFinanceCostFormatFields = () => {
  return (dispatch) => {
    getFinanceCostFormatFieldsApi()
      .then((response) => {
        dispatch(getFinanceCostFormatFieldsSuccess(response.data.response));
      })
      .catch((error) => {
        //toast.error(error.response.data.error.message);
      });
  };
};

const getFinanceCostFormatFieldsApi = () => {
  const headers = {
    Authorization: secureLocalStorage.getItem('aTk'),
  };
  var result;
  result = axios.get(
    'upload-format-fields?app-functionality=PromotionPromoFinanceCostsFormat',
    { headers: headers },
  );
  return result;
};

export const getFinanceCostFormatFieldsSuccess = (data) => {
  return {
    type: FINANCE_COST_FORMAT_FIELDS_SUCCESS,
    data,
  };
};
//get Finance group rates format fields
export const getFinanceGroupRatesFormatFields = () => {
  return (dispatch) => {
    getFinanceGroupRatesFormatFieldsApi()
      .then((response) => {
        dispatch(getFinanceGroupRatesFormatFieldsSuccess(response.data.response));
      })
      .catch((error) => {
      });
  };
};

const getFinanceGroupRatesFormatFieldsApi = () => {
  const headers = {
    Authorization: secureLocalStorage.getItem('aTk'),
  };
  var result;
  result = axios.get(
    'upload-format-fields?app-functionality=PromotionPfAnchorRateFormat',
    { headers: headers },
  );
  return result;
};

export const getFinanceGroupRatesFormatFieldsSuccess = (data) => {
  return {
    type: FINANCE_GROUP_RATES_FORMAT_FIELDS_SUCCESS,
    data,
  };
};

//get Finance Term Split format fields
export const getFinanceTermSplitFormatFields = () => {
  return (dispatch) => {
    getFinanceTermSplitFormatFieldsApi()
      .then((response) => {
        dispatch(getFinanceTermSplitFormatFieldsSuccess(response.data.response));
      })
      .catch((error) => {
      });
  };
};

const getFinanceTermSplitFormatFieldsApi = () => {
  const headers = {
    Authorization: secureLocalStorage.getItem('aTk'),
  };
  var result;
  result = axios.get(
    'upload-format-fields?app-functionality=PromotionPfAnchorSplitFormat',
    { headers: headers },
  );
  return result;
};

export const getFinanceTermSplitFormatFieldsSuccess = (data) => {
  return {
    type: FINANCE_TERM_SPLIT_FORMAT_FIELDS_SUCCESS,
    data,
  };
};
// add/edit/view Finance group rates format
export const addFinanceGroupRateFormatData = (data, id) => {
  return (dispatch) => {
    dispatch(fetchStart());
    addFinanceGroupRateFormatDataApi(data, id)
      .then((response) => {
        toast.success(response.data.response);
        dispatch(fetchEnd());
        history.push('/finance-group-rates/finance-group-rates-excel-upload');
      })
      .catch((error) => {
        dispatch(fetchEnd());
        //toast.error(error.response.data.error.message);
      });
  };
};

const addFinanceGroupRateFormatDataApi = (data, id) => {
  const headers = {
    Authorization: secureLocalStorage.getItem('aTk'),
  };
  var result;
  if (id) {
    result = axios.put(
      'upload-format/' +
      id +
      '?app-functionality=PromotionPfAnchorRateFormat',
      data,
      { headers: headers },
    );
  }
  else {
    result = axios.post(
      'upload-format?app-functionality=PromotionPfAnchorRateFormat',
      data,
      { headers: headers },
    );
  }
  return result;
};
///add Finance term split format
export const addFinanceTermSplitFormatData = (data) => {
  return (dispatch) => {
    dispatch(fetchStart());
    addFinanceTermSplitFormatDataApi(data)
      .then((response) => {
        toast.success(response.data.response);
        dispatch(fetchEnd());
        history.push('/finance-term-split/finance-term-split-excel-upload');
      })
      .catch((error) => {
        dispatch(fetchEnd());
        //toast.error(error.response.data.error.message);
      });
  };
};

const addFinanceTermSplitFormatDataApi = (data) => {
  const headers = {
    Authorization: secureLocalStorage.getItem('aTk'),
  };
  var result;
  result = axios.post(
    'upload-format?app-functionality=PromotionPfAnchorSplitFormat',
    data,
    { headers: headers },
  );
  return result;
};

// update Finance term split format
export const updateFinanceTermSplitFormatData = (id, data) => {
  return (dispatch) => {
    dispatch(fetchStart());
    updateFinanceTermSplitFormatDataApi(id, data)
      .then((response) => {
        dispatch(fetchEnd());
        if (response.status === 201 || response.status === 200) {
          toast.success(response.data.response);
          history.push('/finance-term-split/finance-term-split-excel-upload');
        } else {
        }
      })
      .catch((error) => {
        dispatch(fetchEnd());
      });
  };
};

const updateFinanceTermSplitFormatDataApi = (id, data) => {
  const headers = {
    Authorization: secureLocalStorage.getItem('aTk'),
  };
  var result;
  result = axios.put(
    'upload-format/' +
    id +
    '?app-functionality=PromotionPfAnchorSplitFormat',
    data,
    { headers: headers },
  );
  return result;
};
// delete Finance Group Rates format
export const deleteFinanceGroupRateFormatData = (id) => {
  return (dispatch) => {
    dispatch(fetchStart());
    deleteFinanceGroupRateFormatDataApi(id)
      .then((response) => {
        dispatch(fetchEnd());
        if (response.status === 201 || response.status === 200) {
          toast.success(response.data.response);
          dispatch(getFinanceGroupRateFormatData());
        } else {
        }
      })
      .catch((error) => {
        dispatch(fetchEnd());
      });
  };
};
const deleteFinanceGroupRateFormatDataApi = (id) => {
  const headers = {
    Authorization: secureLocalStorage.getItem('aTk'),
  };
  var result;
  result = axios.delete('upload-format/' + id, { headers: headers });
  return result;
};
// delete Finance term split format
export const deleteFinanceTermSplitFormatData = (id) => {
  return (dispatch) => {
    dispatch(fetchStart());
    deleteFinanceTermSplitFormatDataApi(id)
      .then((response) => {
        dispatch(fetchEnd());
        if (response.status === 201 || response.status === 200) {
          toast.success(response.data.response);
          dispatch(getFinanceTermSplitFormatData());
        } else {
          //toast.error(response.data.error.message);
        }
      })
      .catch((error) => {
        dispatch(fetchEnd());
        //toast.error(error.response.data.error.message);
      });
  };
};
const deleteFinanceTermSplitFormatDataApi = (id) => {
  const headers = {
    Authorization: secureLocalStorage.getItem('aTk'),
  };
  var result;
  result = axios.delete('upload-format/' + id, { headers: headers });
  return result;
};
//upload promo finance Group Rate data file
export const uploadPromoFinanceGroupRateDataFile = (id, file) => {
  return (dispatch) => {
    dispatch(fetchStart());
    uploadPromoFinanceGroupRateDataFileApi(id, file)
      .then((response) => {
        if (response.status === 201 || response.status === 200) {
          dispatch(fetchEnd());
          dispatch(uploadPromoFinanceGroupRateSuccess(response.data.response));
          if (
            response.data.response &&
            response.data.response.success_msg
          ) {
            toast.success(response.data.response.success_msg);
          }
          if (response.data.response?.warning_msg)
            toast.warning('We have some warnings, please check Data log.')
        } else {
        }
      })
      .catch((error) => {
        dispatch(fetchEnd());
      });
  };
};
const uploadPromoFinanceGroupRateDataFileApi = (id, file) => {
  const headers = {
    Authorization: secureLocalStorage.getItem('aTk'),
    'Content-Type': 'multipart/form-data;',
  };
  var result;
  result = axios.post('upload-file?format_id=' + id, file, {
    headers: headers,
  });
  return result;
};

export const uploadPromoFinanceGroupRateSuccess = (data) => {
  return {
    type: PROMO_FINANCE_GROUP_RATE_UPLOAD_SUCCESS,
    data,
  };
};

//upload promo finance term split data file
export const uploadPromoFinanceTermSplitDataFile = (id, file) => {
  return (dispatch) => {
    dispatch(fetchStart());
    uploadPromoFinanceTermSplitDataFileApi(id, file)
      .then((response) => {
        if (response.status === 201 || response.status === 200) {
          dispatch(fetchEnd());
          dispatch(uploadPromoFinanceTermSplitSuccess(response.data.response));
          if (
            response.data.response &&
            response.data.response.success_msg
          ) {
            toast.success(response.data.response.success_msg);
          }
          if (response.data.response?.warning_msg)
            toast.warning('We have some warnings, please check Data log.')
        } else {
        }
      })
      .catch((error) => {
        dispatch(fetchEnd());
      });
  };
};
const uploadPromoFinanceTermSplitDataFileApi = (id, file) => {
  const headers = {
    Authorization: secureLocalStorage.getItem('aTk'),
    'Content-Type': 'multipart/form-data;',
  };
  var result;
  result = axios.post('upload-file?format_id=' + id, file, {
    headers: headers,
  });
  return result;
};

export const uploadPromoFinanceTermSplitSuccess = (data) => {
  return {
    type: PROMO_FINANCE_TERM_SPLIT_UPLOAD_SUCCESS,
    data,
  };
};


// update Finance Cost format
export const updateFinanceCostFormatData = (id, data) => {
  return (dispatch) => {
    dispatch(fetchStart());
    updateFinanceCostFormatDataApi(id, data)
      .then((response) => {
        dispatch(fetchEnd());
        if (response.status === 201 || response.status === 200) {
          toast.success(response.data.response);
          history.push('/finance-cost/finance-cost-excel-upload');
        } else {
          //toast.error(response.data.error.message);
        }
      })
      .catch((error) => {
        dispatch(fetchEnd());
        //toast.error(error.response.data.error.message);
      });
  };
};

const updateFinanceCostFormatDataApi = (id, data) => {
  const headers = {
    Authorization: secureLocalStorage.getItem('aTk'),
  };
  var result;
  result = axios.put(
    'upload-format/' +
    id +
    '?app-functionality=PromotionPromoFinanceCostsFormat',
    data,
    { headers: headers },
  );
  return result;
};

//add Finance Cost format
export const addFinanceCostFormatData = (data) => {
  return (dispatch) => {
    dispatch(fetchStart());
    addFinanceCostFormatDataApi(data)
      .then((response) => {
        toast.success(response.data.response);
        dispatch(fetchEnd());
        history.push('/finance-cost/finance-cost-excel-upload');
      })
      .catch((error) => {
        dispatch(fetchEnd());
        //toast.error(error.response.data.error.message);
      });
  };
};

const addFinanceCostFormatDataApi = (data) => {
  const headers = {
    Authorization: secureLocalStorage.getItem('aTk'),
  };
  var result;
  result = axios.post(
    'upload-format?app-functionality=PromotionPromoFinanceCostsFormat',
    data,
    { headers: headers },
  );
  return result;
};
// delete Coverage Cost format
export const deleteFinanceCostFormatData = (id) => {
  return (dispatch) => {
    dispatch(fetchStart());
    deleteFinanceCostFormatDataApi(id)
      .then((response) => {
        dispatch(fetchEnd());
        if (response.status === 201 || response.status === 200) {
          toast.success(response.data.response);
          dispatch(getFinanceCostFormatData());
        } else {
          //toast.error(response.data.error.message);
        }
      })
      .catch((error) => {
        dispatch(fetchEnd());
        //toast.error(error.response.data.error.message);
      });
  };
};
const deleteFinanceCostFormatDataApi = (id) => {
  const headers = {
    Authorization: secureLocalStorage.getItem('aTk'),
  };
  var result;
  result = axios.delete('upload-format/' + id, { headers: headers });
  return result;
};
export const uploadPromoFinanceCostDataFile = (id, file) => {
  return (dispatch) => {
    dispatch(fetchStart());
    uploadPromoFinanceCostDataFileApi(id, file)
      .then((response) => {
        if (response.status === 201 || response.status === 200) {
          dispatch(fetchEnd());
          dispatch(uploadPromoFinanceCostSuccess(response.data.response));
          if (
            response.data.response &&
            response.data.response.success_msg
          ) {
            toast.success(response.data.response.success_msg);
          }
          if (response.data.response?.warning_msg)
            toast.warning('We have some warnings, please check Data log.')
        } else {
          //toast.error(response.data.complete_error_message);
        }
      })
      .catch((error) => {
        dispatch(fetchEnd());
        //toast.error(error.response.data.complete_error_message);
      });
  };
};
const uploadPromoFinanceCostDataFileApi = (id, file) => {
  const headers = {
    Authorization: secureLocalStorage.getItem('aTk'),
    'Content-Type': 'multipart/form-data;',
  };
  var result;
  result = axios.post('upload-file?format_id=' + id, file, {
    headers: headers,
  });
  return result;
};

export const uploadPromoFinanceCostSuccess = (data) => {
  return {
    type: PROMO_FINANCE_COST_UPLOAD_SUCCESS,
    data,
  };
};

//get Promo Finance Cost details
export const getPromoFinanceCostDetails = (id) => {
  return (dispatch) => {
    dispatch(fetchStart());
    getPromoFinanceCostDetailsApi(id)
      .then((response) => {
        dispatch(fetchEnd());
        dispatch(getPromoFinanceCostDetailsSuccess(response.data.response));
      })
      .catch((error) => {
        //toast.error(error.response.data.error.message);
        dispatch(fetchEnd());
      });
  };
};

const getPromoFinanceCostDetailsApi = (id) => {
  const headers = {
    Authorization: secureLocalStorage.getItem('aTk'),
  };
  var result;
  result = axios.get('promo-finance-cost/' + id, { headers: headers });
  return result;
};

export const getPromoFinanceCostDetailsSuccess = (data) => {
  return {
    type: PROMO_FINANCE_COST_DETAIL_SUCCESS,
    data,
  };
};
//get Promo Finance group rates details
export const getPromoFinanceGroupRatesDetails = (id) => {
  return (dispatch) => {
    dispatch(fetchStart());
    getPromoFinanceGroupRatesDetailsApi(id)
      .then((response) => {
        dispatch(fetchEnd());
        dispatch(getPromoFinanceGroupRatesDetailsSuccess(response.data.response));
      })
      .catch((error) => {
        dispatch(fetchEnd());
      });
  };
};

const getPromoFinanceGroupRatesDetailsApi = (id) => {
  const headers = {
    Authorization: secureLocalStorage.getItem('aTk'),
  };
  var result;
  result = axios.get('/promotion/pf-anchor-rates/' + id, { headers: headers });
  return result;
};

export const getPromoFinanceGroupRatesDetailsSuccess = (data) => {
  return {
    type: PROMO_FINANCE_GROUP_RATES_DETAIL_SUCCESS,
    data,
  };
};
//get Promo Finance term-split details
export const getPromoFinanceTermSplitDetails = (id) => {
  return (dispatch) => {
    dispatch(fetchStart());
    getPromoFinanceTermSplitDetailsApi(id)
      .then((response) => {
        dispatch(fetchEnd());
        dispatch(getPromoFinanceTermSplitDetailsSuccess(response.data.response));
      })
      .catch((error) => {
        //toast.error(error.response.data.error.message);
        dispatch(fetchEnd());
      });
  };
};

const getPromoFinanceTermSplitDetailsApi = (id) => {
  const headers = {
    Authorization: secureLocalStorage.getItem('aTk'),
  };
  var result;
  result = axios.get('/promotion/pf-anchor-splits/' + id, { headers: headers });
  return result;
};

export const getPromoFinanceTermSplitDetailsSuccess = (data) => {
  return {
    type: PROMO_FINANCE_TERM_SPLIT_DETAIL_SUCCESS,
    data,
  };
};

// Promo Territory

export const getPromoTerritoryData = () => {
  return (dispatch) => {
    dispatch(fetchStart());
    getPromoTerritoryDataApi()
      .then((response) => {
        dispatch(fetchEnd());
        dispatch(getPromoTerritoryDataSuccess(response.data.response));
      })
      .catch((error) => {
        dispatch(fetchEnd());
      });
  };
};
const getPromoTerritoryDataApi = () => {
  const headers = {
    Authorization: secureLocalStorage.getItem('aTk'),
  };
  var result;
  result = axios.get('promo-territory?page=1&&limit=0', { headers: headers });
  return result;
};

export const getPromoTerritoryDataSuccess = (data) => {
  return {
    type: PROMO_TERRITORY_DATA_SUCCESS,
    data,
  };
};
export const deletePromoTerritoryData = (id) => {
  return (dispatch) => {
    deletePromoTerritoryDataApi(id).then((response) => {
      toast.success(response.data.response);
      dispatch(getPromoTerritoryData());
    });
  };
};
const deletePromoTerritoryDataApi = (id) => {
  const headers = {
    Authorization: secureLocalStorage.getItem('aTk'),
  };
  var result;
  result = axios.delete('promo-territory/' + id, { headers: headers });
  return result;
};
// Promo Territory format
export const getPromoTerritoryFormatData = () => {
  return (dispatch) => {
    getPromoTerritoryFormatDataApi()
      .then((response) => {
        dispatch(getPromoTerritoryFormatDataSuccess(response.data.response));
      })
      .catch((error) => {
        //toast.error(error.response.data.error.message);
      });
  };
};

const getPromoTerritoryFormatDataApi = () => {
  const headers = {
    Authorization: secureLocalStorage.getItem('aTk'),
  };
  var result;
  result = axios.get(
    'upload-format?app-functionality=PromotionTerritoriesFormat',
    { headers: headers },
  );
  return result;
};

export const getPromoTerritoryFormatDataSuccess = (data) => {
  return {
    type: PROMO_TERRITORY_FORMAT_SUCCESS,
    data,
  };
};

export const getPromoTerritoryFormatDataById = (id) => {
  return (dispatch) => {
    getPromoTerritoryFormatDataByIdApi(id)
      .then((response) => {
        dispatch(
          getPromoTerritoryFormatDataByIdSuccess(response.data.response),
        );
      })
      .catch((error) => {
        //toast.error(error.response.data.error.message);
      });
  };
};

const getPromoTerritoryFormatDataByIdApi = (id) => {
  const headers = {
    Authorization: secureLocalStorage.getItem('aTk'),
  };
  var result;
  result = axios.get(
    'upload-format/' + id + '?app-functionality=PromotionTerritoriesFormat',
    { headers: headers },
  );
  return result;
};

export const getPromoTerritoryFormatDataByIdSuccess = (data) => {
  return {
    type: PROMO_TERRITORY_FORMAT_BY_ID_SUCCESS,
    data,
  };
};

//get Finance Cost format fields
export const getPromoTerritoryFormatFields = () => {
  return (dispatch) => {
    getPromoTerritoryFormatFieldsApi()
      .then((response) => {
        dispatch(getPromoTerritoryFormatFieldsSuccess(response.data.response));
      })
      .catch((error) => {
        //toast.error(error.response.data.error.message);
      });
  };
};

const getPromoTerritoryFormatFieldsApi = () => {
  const headers = {
    Authorization: secureLocalStorage.getItem('aTk'),
  };
  var result;
  result = axios.get(
    'upload-format-fields?app-functionality=PromotionTerritoriesFormat',
    { headers: headers },
  );
  return result;
};

export const getPromoTerritoryFormatFieldsSuccess = (data) => {
  return {
    type: PROMO_TERRITORY_FORMAT_FIELDS_SUCCESS,
    data,
  };
};

// update Promo Territory format
export const updatePromoTerritoryFormatData = (id, data) => {
  return (dispatch) => {
    dispatch(fetchStart());
    updatePromoTerritoryFormatDataApi(id, data)
      .then((response) => {
        dispatch(fetchEnd());
        if (response.status === 201 || response.status === 200) {
          toast.success(response.data.response);
          history.push('/promotion-territory/promotion-territory-excel-upload');
        } else {
          //toast.error(response.data.error.message);
        }
      })
      .catch((error) => {
        dispatch(fetchEnd());
        //toast.error(error.response.data.error.message);
      });
  };
};

const updatePromoTerritoryFormatDataApi = (id, data) => {
  const headers = {
    Authorization: secureLocalStorage.getItem('aTk'),
  };
  var result;
  result = axios.put(
    'upload-format/' + id + '?app-functionality=PromotionTerritoriesFormat',
    data,
    { headers: headers },
  );
  return result;
};

//add Finance Cost format
export const addPromoTerritoryFormatData = (data) => {
  return (dispatch) => {
    dispatch(fetchStart());
    addPromoTerritoryFormatDataApi(data)
      .then((response) => {
        toast.success(response.data.response);
        dispatch(fetchEnd());
        history.push('/promotion-territory/promotion-territory-excel-upload');
      })
      .catch((error) => {
        dispatch(fetchEnd());
        //toast.error(error.response.data.error.message);
      });
  };
};

const addPromoTerritoryFormatDataApi = (data) => {
  const headers = {
    Authorization: secureLocalStorage.getItem('aTk'),
  };
  var result;
  result = axios.post(
    'upload-format?app-functionality=PromotionTerritoriesFormat',
    data,
    { headers: headers },
  );
  return result;
};

// delete Promo Territory format
export const deletePromoTerritoryFormatData = (id) => {
  return (dispatch) => {
    dispatch(fetchStart());
    deletePromoTerritoryFormatDataApi(id)
      .then((response) => {
        dispatch(fetchEnd());
        if (response.status === 201 || response.status === 200) {
          toast.success(response.data.response);
          dispatch(getPromoTerritoryFormatData());
        } else {
          //toast.error(response.data.error.message);
        }
      })
      .catch((error) => {
        dispatch(fetchEnd());
        //toast.error(error.response.data.error.message);
      });
  };
};

const deletePromoTerritoryFormatDataApi = (id) => {
  const headers = {
    Authorization: secureLocalStorage.getItem('aTk'),
  };
  var result;
  result = axios.delete('upload-format/' + id, { headers: headers });
  return result;
};
export const uploadPromoTerritoryDataFile = (id, file) => {
  return (dispatch) => {
    dispatch(fetchStart());
    uploadPromoTerritoryDataFileApi(id, file)
      .then((response) => {
        if (response.status === 201 || response.status === 200) {
          dispatch(fetchEnd());
          dispatch(uploadPromoTerritorySuccess(response.data.response));
          if (
            response.data.response &&
            response.data.response.error_list == null
          ) {
            toast.success(response.data.response.success_msg);
          }
        } else {
          //toast.error(response.data.complete_error_message);
        }
      })
      .catch((error) => {
        dispatch(fetchEnd());
        //toast.error(error.response.data.complete_error_message);
      });
  };
};
const uploadPromoTerritoryDataFileApi = (id, file) => {
  const headers = {
    Authorization: secureLocalStorage.getItem('aTk'),
    'Content-Type': 'multipart/form-data;',
  };
  var result;
  result = axios.post('upload-file?format_id=' + id, file, {
    headers: headers,
  });
  return result;
};
export const uploadPromoTerritorySuccess = (data) => {
  return {
    type: PROMO_TERRITORY_UPLOAD_SUCCESS,
    data,
  };
};

//get country
export const getCountryData = (country, id) => {
  return (dispatch) => {
    getCountryDataAPI(country, id)
      .then((response) => {
        if (id) dispatch(getIdDataSuccess(response.data.response));
        else dispatch(getCountryDataSuccess(response.data.response));
      })
      .catch((error) => { });
  };
};

const getCountryDataAPI = (country, id) => {
  const headers = {
    Authorization: secureLocalStorage.getItem('aTk'),
  };
  var result;
  if (id)
    result = axios.get('promo-territory-by-value?id=' + id, {
      headers: headers,
    });
  else
    result = axios.get('promo-territory-by-value?country=' + country, {
      headers: headers,
    });
  return result;
};

export const getCountryDataSuccess = (data) => {
  return {
    type: COUNTRY_SUCCESS,
    data,
  };
};

export const getIdDataSuccess = (data) => {
  return {
    type: TERRITORY_ID_SUCCESS,
    data,
  };
};

//promotion mapping
export const createPromotionMapping = (data, type, id) => {
  return (dispatch) => {
    dispatch(fetchStart());
    createPromotionMappingAPI(data, type, id)
      .then((response) => {
        dispatch(fetchEnd());
        toast.success(response.data.response);
        dispatch(getPromotionMappingData(1, 0));

        history.push('/promo-mapping');
      })
      .catch((error) => {
        dispatch(fetchEnd());
      });
  };
};

const createPromotionMappingAPI = (data, type, id) => {
  const headers = {
    Authorization: secureLocalStorage.getItem('aTk'),
  };
  var result;
  if (type === 'delete') {
    result = axios.delete('promotion-mapping/' + id, { headers: headers });
  } else if (type === 'edit') {
    result = axios.put('promotion-mapping/' + id, data, { headers: headers });
  } else {
    result = axios.post('promotion-mapping', data, { headers: headers });
  }
  return result;
};
export const getPromotionMappingData = (pagination, limit) => {
  return (dispatch) => {
    getPromotionMappingDataApi(pagination, limit).then((response) => {
      dispatch(getPromotionMappingDataSuccess(response.data.response));
    });
  };
};
const getPromotionMappingDataApi = (pagination, limit) => {
  const headers = {
    Authorization: secureLocalStorage.getItem('aTk'),
  };
  var result;
  result = axios.get(
    'promotion-mapping?page=' + pagination + '&&limit=' + limit,
    { headers: headers },
  );
  return result;
};
export const getPromotionMappingDataSuccess = (data) => {
  return {
    type: PROMO_MAP_SUCCESS,
    data,
  };
};
export const getPromotionMappingSingleItem = (id) => {
  return (dispatch) => {
    getPromotionMappingSingleItemAPI(id).then((response) => {
      dispatch(getPromotionMappingSingleItemSuccess(response.data.response));
    });
  };
};
const getPromotionMappingSingleItemAPI = (id) => {
  const headers = {
    Authorization: secureLocalStorage.getItem('aTk'),
  };
  var result;
  result = axios.get('promotion-mapping/' + id, { headers: headers });
  return result;
};

export const getPromotionMappingSingleItemSuccess = (data) => {
  return {
    type: PROMO_MAP_SINGLE_SUCCESS,
    data,
  };
};

//promo-mapping-format
export const getPromotionMappingFormatData = () => {
  return (dispatch) => {
    getPromotionMappingFormatDataApi()
      .then((response) => {
        dispatch(getPromotionMappingFormatDataSuccess(response.data.response));
      })
      .catch((error) => {
        //toast.error(error.response.data.error.message);
      });
  };
};

const getPromotionMappingFormatDataApi = () => {
  const headers = {
    Authorization: secureLocalStorage.getItem('aTk'),
  };
  var result;
  result = axios.get(
    'upload-format?app-functionality=PromotionVistexMappingFormat ',
    { headers: headers },
  );
  return result;
};

export const getPromotionMappingFormatDataSuccess = (data) => {
  return {
    type: PROMO_MAPPING_FORMAT_SUCCESS,
    data,
  };
};

export const getPromotionMappingFormatDataById = (id) => {
  return (dispatch) => {
    getPromotionMappingFormatDataByIdApi(id)
      .then((response) => {
        dispatch(
          getPromotionMappingFormatDataByIdSuccess(response.data.response),
        );
      })
      .catch((error) => {
        //toast.error(error.response.data.error.message);
      });
  };
};

const getPromotionMappingFormatDataByIdApi = (id) => {
  const headers = {
    Authorization: secureLocalStorage.getItem('aTk'),
  };
  var result;
  result = axios.get('upload-format/' + id, { headers: headers });
  return result;
};

export const getPromotionMappingFormatDataByIdSuccess = (data) => {
  return {
    type: PROMO_MAP_FORMAT_BY_ID,
    data,
  };
};

export const getPromotionMappingFormatFields = () => {
  return (dispatch) => {
    getPromotionMappingFormatFieldsApi()
      .then((response) => {
        dispatch(
          getPromotionMappingFormatFieldsSuccess(response.data.response),
        );
      })
      .catch((error) => {
        ////toast.error(error.response.data.error.message);
      });
  };
};

const getPromotionMappingFormatFieldsApi = () => {
  const headers = {
    Authorization: secureLocalStorage.getItem('aTk'),
  };
  var result;
  result = axios.get(
    'upload-format-fields?app-functionality=PromotionVistexMappingFormat ',
    { headers: headers },
  );
  return result;
};

export const getPromotionMappingFormatFieldsSuccess = (data) => {
  return {
    type: PROMO_MAP_FORMAT_FIELDS,
    data,
  };
};

export const updatePromotionMappingFormatData = (id, data) => {
  return (dispatch) => {
    dispatch(fetchStart());
    updatePromotionMappingFormatDataApi(id, data)
      .then((response) => {
        dispatch(fetchEnd());
        if (response.status === 201 || response.status === 200) {
          toast.success(response.data.response);
          history.push('/promo-mapping/promo-mapping-excel-upload');
        } else {
          ////toast.error(ServerError);
        }
      })
      .catch((error) => {
        dispatch(fetchEnd());
        //toast.error(error.response.data.complete_error_message);
      });
  };
};

const updatePromotionMappingFormatDataApi = (id, data) => {
  const headers = {
    Authorization: secureLocalStorage.getItem('aTk'),
  };
  var result;
  result = axios.put(
    'upload-format/' +
    id +
    '?app-functionality=PromotionVistexMappingFormat',
    data,
    { headers: headers },
  );
  return result;
};
export const addPromotionMappingFormatData = (data) => {
  return (dispatch) => {
    dispatch(fetchStart());
    addPromotionMappingFormatDataApi(data)
      .then((response) => {
        dispatch(fetchEnd());
        //dispatch(getPromotionMappingFormatData())
        toast.success(response.data.response);
        history.push('/promo-mapping/promo-mapping-excel-upload');
      })
      .catch((error) => {
        dispatch(fetchEnd());
        //toast.error(error.response.data.error.message);
      });
  };
};

const addPromotionMappingFormatDataApi = (data) => {
  const headers = {
    Authorization: secureLocalStorage.getItem('aTk'),
  };
  var result;
  result = axios.post(
    'upload-format?app-functionality=PromotionVistexMappingFormat',
    data,
    { headers: headers },
  );
  return result;
};

export const deletePromotionMappingFormatData = (id) => {
  return (dispatch) => {
    dispatch(fetchStart());
    deletePromotionMappingFormatDataApi(id)
      .then((response) => {
        dispatch(fetchEnd());
        if (response.status === 201 || response.status === 200) {
          toast.success('Successfully deleted');
          dispatch(getPromotionMappingFormatData());
        } else {
          ////toast.error(ServerError);
        }
      })
      .catch((error) => {
        dispatch(fetchEnd());
        ////toast.error(ServerError);
      });
  };
};

const deletePromotionMappingFormatDataApi = (id) => {
  const headers = {
    Authorization: secureLocalStorage.getItem('aTk'),
  };
  var result;
  result = axios.delete('upload-format/' + id, { headers: headers });
  return result;
};

export const uploadPromotionMappingFile = (id, file) => {
  return (dispatch) => {
    uploadPromotionMappingFileApi(id, file)
      .then((response) => {
        if (response.status === 201 || response.status === 200) {
          //window.location.reload();
          toast.success(response.data.response.success_msg);
        } else {
          //toast.error(response.data.complete_error_message);
        }
      })
      .catch((error) => {
        //toast.error(error.response.data.complete_error_message);
      });
  };
};

const uploadPromotionMappingFileApi = (id, file) => {
  const headers = {
    Authorization: secureLocalStorage.getItem('aTk'),
    'Content-Type': 'multipart/form-data;',
  };
  var result;
  result = axios.post('upload-file?format_id=' + id, file, {
    headers: headers,
  });
  return result;
};
export const getPromoTypes = (country, productLine) => {
  return (dispatch) => {
    getPromoTypesApi(country, productLine)
      .then((response) => {
        dispatch(getPromoTypesSuccess(response.data.response));
      })
      .catch((error) => {
        ////toast.error(error.response.data.error.message);
      });
  };
};

const getPromoTypesApi = (country, productLine) => {
  const headers = {
    Authorization: secureLocalStorage.getItem('aTk'),
  };
  var result;
  if (country && productLine) {
    result = axios.get(
      '/promotion-sticker-types?country=' +
      country +
      '&product_lines=' +
      productLine,
      { headers: headers },
    );
  } else {
    result = axios.get('/promotion-sticker-types', { headers: headers });
  }
  return result;
};

export const getPromoTypesSuccess = (data) => {
  return {
    type: PROMO_TYPES,
    data,
  };
};

export const getPromoStickers = (
  productLines,
  country,
  id,
  pagination,
  limit,
  page,
  data,
  type,
) => {
  return (dispatch) => {
    dispatch(fetchStart());
    getPromoStickersApi(
      productLines,
      country,
      id,
      pagination,
      limit,
      page,
      data,
    )
      .then((response) => {
        dispatch(fetchEnd());
        if (
          id &&
          page &&
          (page === 'TR' ||
            page === 'filtered_list' ||
            page === 'sticker_bank_view' || page === 'exception_report')
        ) {
          dispatch(getPromoStickerByIdSuccess(response.data.response));
        } else if (id && page && page != 'list') {
          dispatch(getPromoStickerByIdSuccess(response.data.response));
          //history.push('/promotion-sticker-setup/edit/' + id)
          if (type === 'stickerBankClone')
            history.push({
              pathname: '/promotion-sticker-setup/clone',
              data: { page: page },
            });
          else
            history.push({
              pathname: '/promotion-sticker-setup/edit/' + id,
              data: {
                page: page,
                ...(page === 'budget-setup' && { isStickerUsed: data.isStickerUsed, planID: data.planID, mode: data.mode })
              },
            });
        } else dispatch(getPromoStickersSuccess(response.data.response));
      })
      .catch((error) => {
        dispatch(fetchEnd());
      });
  };
};

const getPromoStickersApi = (
  productLines,
  country,
  id,
  pagination,
  limit,
  page,
  data,
) => {
  const headers = {
    Authorization: secureLocalStorage.getItem('aTk'),
  };
  var result;
  if (id) {
    if (page == 'list' || page === 'filtered_list')
      result = axios.get('/promotion-stickers?id.in=' + id, {
        headers: headers,
      });
    else if (page == 'TR')
      result = axios.get(
        '/promotion-sticker/' +
        id +
        '?country=' +
        country +
        '&product_lines=' +
        productLines,
        { headers: headers },
      );
    else result = axios.get('/promotion-sticker/' + id, { headers: headers });
  } else if (pagination)
    result = axios.get(
      '/promotion-stickers?page=' +
      pagination +
      '&&limit=' +
      limit +
      '&product_line.in=' +
      productLines +
      '&country=' +
      country,
      { headers: headers },
    );
  else if (page === 'filter') {
    result = axios.get(
      '/promotion-stickers',
      { params: data, headers: headers },
    );
  } else
    result = axios.get(
      '/promotion-stickers?product_line.in=' +
      productLines +
      '&country=' +
      country,
      { headers: headers },
    );
  return result;
};

export const getPromoStickersSuccess = (data) => {
  return {
    type: PROMO_STICKERS,
    data,
  };
};
export const getPromoStickerByIdSuccess = (data) => {
  return {
    type: PROMO_STICKER_BY_ID,
    data,
  };
};
export const clearPromoStickerByIdSuccess = () => {
  return {
    type: CLEAR_PROMO_STICKER_BY_ID,
  };
};
export const createStickers = (data, type, value, page, isOvrtUpdated, isUsed, mode) => {
  return (dispatch) => {
    dispatch(fetchStart());
    const storedFilters = JSON.parse(sessionStorage.getItem('sticker_bank_filters') || '{}');
    const updatedFilters = Object.keys(storedFilters).length > 0 ? handleFilterData(storedFilters, value?.product_line, value?.country) : {}
    createStickersAPI(data, type, value, isOvrtUpdated, isUsed, page)
      .then((response) => {
        dispatch(fetchEnd());
        if (response.data.response) {
          toast.success(
            <div style={{ whiteSpace: 'pre-line' }}>
              {response.data.response}
            </div>,
          );
        }
        if (response.data.warning_message) {
          toast.warn(
            <div style={{ whiteSpace: 'pre-line' }}>
              {response.data.warning_message}
            </div>,
          );
        }
        if (response.data.stickerId && type === 'clone' && page === 'budget-setup') {
          dispatch(getBudgetClonedSticker(response.data.stickerId));
        }

        if (response.data.id && (type === 'edit' || type === 'create') && page === 'budget-setup') {
          dispatch(getBudgetClonedSticker(response.data.id));
        }

        if (type == 'create' || type == 'edit') {
          if (page === 'budget-setup')
            history.push({
              pathname: value && mode === 'edit' ? `/promotion-budget-setup/edit/${value}` : '/promotion-budget-setup',
              data: {
                country: data.countries[0],
                productLine: data.product_lines,
                isVisited: true,
                page: page,
                ...((type === 'create' && response.data.id) && { id: response.data.id })
              },
            });
          else if (page == 'Scenario')
            history.push({
              pathname: '/promotion-scenario-setup',
              data: {
                country: data.countries[0],
                productLine: data.product_lines,
                isVisited: true,
                page: page,
              },
            });
          else if (type === 'create')
            history.push({
              pathname: '/promotion-sticker-setup',
              data: {
                country: data.countries[0],
                productLine: data.product_lines,
                isVisited: true,
              },
            });
          else if (type === 'edit')
            history.push({
              pathname: '/promotion-sticker-setup',
              data: {
                country: data.countries[0],
                productLine: data.product_lines,
                isVisited: true,
              },
            });
        }
        if (type == 'delete' || type == 'clone') {
          if (page === 'budget-setup' && type === 'delete') {
            var payload = {
              'product_line': value.product_line,
              'country.in': ["USA", "CA"].join(","),
              'is_budget': true,
            }
            dispatch(getPromoStickers(value.product_line, value.country, null, null, null, 'filter', payload));
          }
          else if (page === 'budget-setup') {
            if (value.ID) delete value.ID;
            dispatch(getPromoStickers(value.product_line, value.country, null, null, null, 'filter', value));
          }
          else if (Object.keys(updatedFilters).length > 0)
            dispatch(getPromoStickers(value.product_line, value.country, null, null, null, 'filter', updatedFilters))
          else
            dispatch(getPromoStickers(value.product_line, value.country));
        }
      })
      .catch((error) => {
        dispatch(fetchEnd());
        // if (error.response && error.response.data && error.response.data.complete_error_message)
        //   toast.error(error.response.data.complete_error_message);
      });
  };
};

const handleFilterData = (filters, productLine, country) => {
  const updatedFilters = {
    'product_line.in': productLine,
    'country': country,
  };

  const keyMap = {
    promoType: 'promotion_type',
    status: 'approval_status',
    version: 'versioning',
    takeRate: 'takerate',
    createdBy: 'created_by',
  };

  Object.entries(filters).forEach(([key, value]) => {
    if (keyMap[key] && Array.isArray(value) && value.length > 0) {
      updatedFilters[keyMap[key]] = value.join(',');
    }
  });

  return updatedFilters;
};

const createStickersAPI = (data, type, value, isOvrtUpdated, isUsed, page) => {
  const headers = {
    Authorization: secureLocalStorage.getItem('aTk'),
  };
  var result;
  if (type === 'create')
    result = axios.post('/promotion-sticker', data, {
      headers: headers,
    });
  else if (type === 'delete')
    result = axios.delete(
      '/promotion-sticker/' + value.ID,
      { params: data, headers: headers },
    );
  else if (type == 'clone')
    result = axios.post(
      '/promotion-sticker/' + value.ID + '/clone' + (page === 'budget-setup' ? '?is_budget=true' : ''),
      { headers: headers },
    );
  else if (page === 'budget-setup' && isUsed !== undefined)
    result = axios.put('/promotion/update-budget-sticker?used=' + isUsed + '&plan_id=' + value, data, {
      headers: headers,
    });
  else
    result = axios.put(
      '/promotion-sticker/' + value + '?update_overwrite=' + isOvrtUpdated,
      data,
      {
        headers: headers,
      },
    );
  return result;
};

export const getMaterialFilters = (table) => {
  return (dispatch) => {
    getMaterialFiltersApi(table)
      .then((response) => {
        dispatch(getMaterialFiltersSuccess(response.data.response));
      })
      .catch((error) => { });
  };
};

//create stickers archive
export const createStickerArchive = (id, productline, country) => {
  return (dispatch) => {
    dispatch(fetchStart());
    getCreateStickerArchiveApi(id)
      .then((response) => {
        dispatch(fetchEnd());
        toast.success(response.data.response);
        const storedFilters = JSON.parse(sessionStorage.getItem('sticker_bank_filters') || '{}');
        const updatedFilters = Object.keys(storedFilters).length > 0 ? handleFilterData(storedFilters, productline, country) : {}
        if (Object.keys(updatedFilters).length > 0)
          dispatch(getPromoStickers(productline, country, null, null, null, 'filter', updatedFilters));
        else
          dispatch(getPromoStickers(productline, country));
      })
      .catch((error) => {
        dispatch(fetchEnd());
        // toast.error('Something went wrong.');
      });
  };
};

const getCreateStickerArchiveApi = (id) => {
  const headers = {
    Authorization: secureLocalStorage.getItem('aTk'),
  };
  var result;
  result = axios.put(
    'promotion/' + id + '/archive?table_name=promotion_stickers',
    {
      headers: headers,
    },
  );
  return result;
};

export const getBudgetClonedSticker = (data) => {
  return {
    type: BUDGET_STICKER_CLONED_DATA,
    data,
  };
};

// stickers archive list
export const getStickerArchiveList = (productLine, country, type, data) => {
  return (dispatch) => {
    dispatch(fetchStart());
    getStickerArchiveListApi(productLine, country, type, data)
      .then((response) => {
        dispatch(fetchEnd());
        dispatch(getStickerArchiveListSuccess(response.data.response));
      })
      .catch((error) => {
        dispatch(fetchEnd());
        //toast.error(error.response.data.error.message);
      });
  };
};

const getStickerArchiveListApi = (productLine, country, type, data) => {
  const headers = {
    Authorization: secureLocalStorage.getItem('aTk'),
  };
  var result;

  if (type === 'filter') {
    result = axios.get(
      '/promotion-stickers',
      { params: data, headers: headers },
    );
  } else
    result = axios.get(
      'promotion-stickers?product_line.in=' +
      productLine +
      '&country=' +
      country +
      '&archive=true',
      { headers: headers },
    );

  return result;
};

export const getStickerArchiveListSuccess = (data) => {
  return {
    type: STICKER_ARCHIVE,
    data,
  };
};

const getMaterialFiltersApi = (table) => {
  const headers = {
    Authorization: secureLocalStorage.getItem('aTk'),
  };
  var result;

  result = axios.get('promotion-filter-group', { headers: headers });
  return result;
};

export const getMaterialFiltersSuccess = (data) => {
  return {
    type: PROMO_FILTERS,
    data,
  };
};

export const getMarketFilters = (table, data) => {
  return (dispatch) => {
    getMarketFiltersApi(table, data)
      .then((response) => {
        dispatch(getMarketFiltersSuccess(response.data.response));
      })
      .catch((error) => { });
  };
};

const getMarketFiltersApi = (table, data) => {
  const headers = {
    Authorization: secureLocalStorage.getItem('aTk'),
  };
  var result;

  result = axios.post('promotion-market-filters?table_name=' + table, data, {
    headers: headers,
  });
  return result;
};

export const getMarketFiltersSuccess = (data) => {
  return {
    type: MARKET_FILTERS,
    data,
  };
};

export const getModels = (table, data, type) => {
  return (dispatch) => {
    getModelsApi(table, data)
      .then((response) => {
        if (table === 'promotion_material_master') {
          if (type == 'filter')
            dispatch(getModelsSuccess(response.data.response));
          else dispatch(getModelsListSuccess(response.data.response));
        } else {
          if (type == 'search&filter')
            dispatch(getFilteredLocationSuccess(response.data.response));
          else dispatch(getLocationSuccess(response.data.response));
        }
      })
      .catch((error) => { });
  };
};

const getModelsApi = (table, data) => {
  const headers = {
    Authorization: secureLocalStorage.getItem('aTk'),
  };
  var result;

  result = axios.post('promotion-define-market', data, { headers: headers });
  return result;
};

export const getModelsSuccess = (data) => {
  return {
    type: MODEL_GROUP,
    data,
  };
};
export const getModelsListSuccess = (data) => {
  return {
    type: MODEL_LIST_GROUP,
    data,
  };
};
export const getLocationSuccess = (data) => {
  return {
    type: LOCATION_GROUP,
    data,
  };
};
export const getFilteredLocationSuccess = (data) => {
  return {
    type: LOCATION_FILTER,
    data,
  };
};
// Promotion Config

// ADD edit Promotion Config
export const addPromoConfigFormatData = (data, id) => {
  return (dispatch) => {
    dispatch(fetchStart());
    addPromoConfigFormatDataApi(data, id)
      .then((response) => {
        toast.success(response.data.response);
        dispatch(fetchEnd());
        history.push('/promo-config/excel-upload');
      })
      .catch((error) => {
        dispatch(fetchEnd());
        //toast.error(error.response.data.error.message);
      });
  };
};

const addPromoConfigFormatDataApi = (data, id) => {
  const headers = {
    Authorization: secureLocalStorage.getItem('aTk'),
  };
  var result;
  if (id) {
    result = axios.put(
      'upload-format/' +
      id +
      '?app-functionality=PromotionConfigurationsFormat',
      data,
      { headers: headers },
    );
  } else {
    result = axios.post(
      'upload-format?app-functionality=PromotionConfigurationsFormat',
      data,
      { headers: headers },
    );
  }
  return result;
};

// delete promo config

export const deletePromoConfigFormatData = (id) => {
  return (dispatch) => {
    dispatch(fetchStart());
    deletePromoConfigFormatDataApi(id)
      .then((response) => {
        dispatch(fetchEnd());
        if (response.status === 201 || response.status === 200) {
          toast.success(response.data.response);
          dispatch(getPromoConfigFormatData());
        } else {
          //toast.error(response.data.error.message);
        }
      })
      .catch((error) => {
        dispatch(fetchEnd());
        //toast.error(error.response.data.error.message);
      });
  };
};

const deletePromoConfigFormatDataApi = (id) => {
  const headers = {
    Authorization: secureLocalStorage.getItem('aTk'),
  };
  var result;
  result = axios.delete('upload-format/' + id, { headers: headers });
  return result;
};

// upload promo config file

export const uploadPromoConfigDataFile = (id, file) => {
  return (dispatch) => {
    dispatch(fetchStart());
    uploadPromoConfigDataFileApi(id, file)
      .then((response) => {
        if (response.status === 201 || response.status === 200) {
          dispatch(fetchEnd());
          dispatch(uploadPromoConfigSuccess(response.data.response));
          if (
            response.data.response &&
            response.data.response.error_list == null
          ) {
            toast.success(response.data.response.success_msg);
          }
        } else {
          //toast.error(response.data.complete_error_message);
        }
      })
      .catch((error) => {
        dispatch(fetchEnd());
        //toast.error(error.response.data.complete_error_message);
      });
  };
};
const uploadPromoConfigDataFileApi = (id, file) => {
  const headers = {
    Authorization: secureLocalStorage.getItem('aTk'),
    'Content-Type': 'multipart/form-data;',
  };
  var result;
  result = axios.post('upload-file?format_id=' + id, file, {
    headers: headers,
  });
  return result;
};

export const uploadPromoConfigSuccess = (data) => {
  return {
    type: PROMO_CONFIG_UPLOAD_SUCCESS,
    data,
  };
};

//get Promotion Config format fields

export const getPromoConfigFormatFields = () => {
  return (dispatch) => {
    getPromoConfigFormatFieldsApi()
      .then((response) => {
        dispatch(getPromoConfigFormatFieldsSuccess(response.data.response));
      })
      .catch((error) => {
        //toast.error(error.response.data.error.message);
      });
  };
};

const getPromoConfigFormatFieldsApi = () => {
  const headers = {
    Authorization: secureLocalStorage.getItem('aTk'),
  };
  var result;
  result = axios.get(
    'upload-format-fields?app-functionality=PromotionConfigurationsFormat',
    { headers: headers },
  );
  return result;
};

export const getPromoConfigFormatFieldsSuccess = (data) => {
  return {
    type: PROMO_CONFIG_FORMAT_FIELDS_SUCCESS,
    data,
  };
};

//get promo config format data

export const getPromoConfigFormatData = () => {
  return (dispatch) => {
    getPromoConfigFormatDataApi()
      .then((response) => {
        dispatch(getPromoConfigFormatDataSuccess(response.data.response));
      })
      .catch((error) => {
        //toast.error(error.response.data.error.message);
      });
  };
};

const getPromoConfigFormatDataApi = () => {
  const headers = {
    Authorization: secureLocalStorage.getItem('aTk'),
  };
  var result;
  result = axios.get(
    'upload-format?app-functionality=PromotionConfigurationsFormat',
    { headers: headers },
  );
  return result;
};

export const getPromoConfigFormatDataSuccess = (data) => {
  return {
    type: PROMO_CONFIG_FORMAT_SUCCESS,
    data,
  };
};

//get promotion config table data

export const getPromoConfigData = () => {
  return (dispatch) => {
    dispatch(fetchStart());
    getPromoConfigDataApi()
      .then((response) => {
        dispatch(fetchEnd());
        dispatch(getPromoConfigDataSuccess(response.data.response));
      })
      .catch((error) => {
        dispatch(fetchEnd());
      });
  };
};
const getPromoConfigDataApi = () => {
  const headers = {
    Authorization: secureLocalStorage.getItem('aTk'),
  };
  var result;
  result = axios.get('promotion-config?page=1&&limit=0', { headers: headers });
  return result;
};

export const getPromoConfigDataSuccess = (data) => {
  return {
    type: PROMO_CONFIG_DATA_SUCCESS,
    data,
  };
};

//delete promotion config table data

export const deletePromoConfigData = (id) => {
  return (dispatch) => {
    deletePromoConfigDataApi(id).then((response) => {
      toast.success(response.data.response);
      dispatch(getPromoConfigData());
    });
  };
};
const deletePromoConfigDataApi = (id) => {
  const headers = {
    Authorization: secureLocalStorage.getItem('aTk'),
  };
  var result;
  result = axios.delete('promotion-config/' + id, { headers: headers });
  return result;
};

//material pricing

// add edit material pricing
export const addMaterialPricingFormatData = (data, id) => {
  return (dispatch) => {
    dispatch(fetchStart());
    addMaterialPricingFormatDataApi(data, id)
      .then((response) => {
        toast.success(response.data.response);
        dispatch(fetchEnd());
        history.push('/material-pricing/excel-upload');
      })
      .catch((error) => {
        dispatch(fetchEnd());
        //toast.error(error.response.data.error.message);
      });
  };
};

const addMaterialPricingFormatDataApi = (data, id) => {
  const headers = {
    Authorization: secureLocalStorage.getItem('aTk'),
  };
  var result;
  if (id) {
    result = axios.put(
      'upload-format/' + id + '?app-functionality=PromotionMaterialPricingsFormat',
      data,
      { headers: headers },
    );
  } else {
    result = axios.post(
      'upload-format?app-functionality=PromotionMaterialPricingsFormat',
      data,
      { headers: headers },
    );
  }
  return result;
};

// delete material pricing

export const deleteMaterialPricingFormatData = (id) => {
  return (dispatch) => {
    dispatch(fetchStart());
    deleteMaterialPricingFormatDataApi(id)
      .then((response) => {
        dispatch(fetchEnd());
        if (response.status === 201 || response.status === 200) {
          toast.success(response.data.response);
          dispatch(getMaterialPricingFormatData());
        } else {
          //toast.error(response.data.error.message);
        }
      })
      .catch((error) => {
        dispatch(fetchEnd());
        //toast.error(error.response.data.error.message);
      });
  };
};

const deleteMaterialPricingFormatDataApi = (id) => {
  const headers = {
    Authorization: secureLocalStorage.getItem('aTk'),
  };
  var result;
  result = axios.delete('upload-format/' + id, { headers: headers });
  return result;
};

//upload material pricing data file

export const uploadMaterialPricingDataFile = (id, file) => {
  return (dispatch) => {
    dispatch(fetchStart());
    uploadMaterialPricingDataFileApi(id, file)
      .then((response) => {
        if (response.status === 201 || response.status === 200) {
          dispatch(fetchEnd());
          dispatch(uploadMaterialPricingSuccess(response.data.response));
          if (
            response.data.response &&
            response.data.response.error_list == null
          ) {
            toast.success(response.data.response.success_msg);
          }
        } else {
          //toast.error(response.data.complete_error_message);
        }
      })
      .catch((error) => {
        dispatch(fetchEnd());
        //toast.error(error.response.data.complete_error_message);
      });
  };
};
const uploadMaterialPricingDataFileApi = (id, file) => {
  const headers = {
    Authorization: secureLocalStorage.getItem('aTk'),
    'Content-Type': 'multipart/form-data;',
  };
  var result;
  result = axios.post('upload-file?format_id=' + id, file, {
    headers: headers,
  });
  return result;
};

export const uploadMaterialPricingSuccess = (data) => {
  return {
    type: MATERIAL_PRICING_UPLOAD_SUCCESS,
    data,
  };
};

//get Material Pricing format fields

export const getMaterialPricingFormatFields = () => {
  return (dispatch) => {
    getMaterialPricingFormatFieldsApi()
      .then((response) => {
        dispatch(getMaterialPricingFormatFieldsSuccess(response.data.response));
      })
      .catch((error) => {
        //toast.error(error.response.data.error.message);
      });
  };
};

const getMaterialPricingFormatFieldsApi = () => {
  const headers = {
    Authorization: secureLocalStorage.getItem('aTk'),
  };
  var result;
  result = axios.get(
    'upload-format-fields?app-functionality=PromotionMaterialPricingsFormat',
    { headers: headers },
  );
  return result;
};

export const getMaterialPricingFormatFieldsSuccess = (data) => {
  return {
    type: MATERIAL_PRICING_FORMAT_FIELDS_SUCCESS,
    data,
  };
};

//get Material Pricing format data

export const getMaterialPricingFormatData = () => {
  return (dispatch) => {
    getMaterialPricingFormatDataApi()
      .then((response) => {
        dispatch(getMaterialPricingFormatDataSuccess(response.data.response));
      })
      .catch((error) => {
        //toast.error(error.response.data.error.message);
      });
  };
};

const getMaterialPricingFormatDataApi = () => {
  const headers = {
    Authorization: secureLocalStorage.getItem('aTk'),
  };
  var result;
  result = axios.get('upload-format?app-functionality=PromotionMaterialPricingsFormat', {
    headers: headers,
  });
  return result;
};

export const getMaterialPricingFormatDataSuccess = (data) => {
  return {
    type: MATERIAL_PRICING_FORMAT_SUCCESS,
    data,
  };
};

export const CostingSimulationStart = (data) => {
  if (data == 'market') {
    return {
      type: MARKET_START,
      data,
    };
  } else {
    return {
      type: COSTING_START,
      data,
    };
  }
};
export const CostingSimulationEnd = (data) => {
  if (data == 'market')
    return {
      type: MARKET_END,
      data,
    };
  else
    return {
      type: COSTING_END,
      data,
    };
};

//create scenario
export const PromotionScenario = (data, id, type, saveType) => {
  return (dispatch) => {
    dispatch(getPromoScenarioData(null, true));
    PromotionScenarioAPI(data, id, type)
      .then((response) => {

        if (saveType == 'grid-update') { //for calling accessgrid Api when we delete or change sticker
          dispatch(getAccessGrid(id))
          const recalculateCosting = sessionStorage.getItem('recalculate_costing') === 'true';
          if (recalculateCosting)
            toast.info("Working on the costing...")
        }
        if (saveType !== 'auto_save') toast.success(response.data.response);
        if (['edit', 'prefill', 'last_activity', 'view', 'fetch_id'].includes(type)) {
          dispatch(getPromoScenarioData(response.data.response, false));
          if (type == 'edit' || type == 'last_activity')
            history.push({
              pathname: '/promotion-scenario-setup/edit/' + id,
              data: { page: type },
            });
          else if (type == 'view') {
            history.push({
              pathname: '/promotion-scenario-setup/view/' + id,
              data: { page: type },
            });
          }
        }
        else dispatch(getPromoScenarioData(response.data.data, false));
      })
      .catch((error) => {
        dispatch(getPromoScenarioData(null, false));
      });
  };
};

const PromotionScenarioAPI = (data, id, type) => {
  const headers = {
    Authorization: secureLocalStorage.getItem('aTk'),
  };
  var result;
  if (type == 'delete')
    result = axios.delete('promotion/scenario/' + id, { headers: headers });
  if (['edit', 'prefill', 'last_activity', 'view', 'fetch_id'].includes(type))//fetch particular scenario
    result = axios.post('promotion/scenario', data, { headers: headers });
  else
    result = axios.post('promotion/scenarios', data, { headers: headers });//saving scenario
  //}
  return result;
};

export const getPromoScenarioData = (data, loader) => {
  return {
    type: SCENARIO_DATA,
    data,
    loader,
  };
};
// export const getClearData = () => {
//   return {
//     type: CLEAR_DATA
//   };
// };
//old-ne
export const createPromotionScenario = (data, id, type, page) => {
  return (dispatch) => {
    dispatch(fetchStart());
    createPromotionScenarioAPI(data, id, type)
      .then((response) => {
        dispatch(fetchEnd());
        if (type == 'fetch_id') {
          dispatch(getPromoScenarioById(response.data.response));
          if (page == 'edit')
            history.push({
              pathname: '/promotion-scenario-setup/edit/' + id,
              data: { page: page },
            });
          else {
            if (page !== 'prefillGrid')
              history.push({
                pathname: '/promotion-scenario-setup',
                data: { page: page },
              });
          }
        } else {
          if (
            type == 'partial_save' ||
            page == 'partial_save' ||
            page == 'review'
          ) {
            dispatch(getSavedScenario(response.data.data));
          } else
            history.push({
              pathname: '/promotion-dashboard',
              data: { productLine: data.product_lines, page: type },
            });
          toast.success(response.data.response);
          if (response.data.warning_message)
            toast.warn(response.data.warning_message);
        }
      })
      .catch((error) => {
        dispatch(fetchEnd());
      });
  };
};

const createPromotionScenarioAPI = (data, id, type) => {
  const headers = {
    Authorization: secureLocalStorage.getItem('aTk'),
  };
  var result;
  if (type == 'fetch_id') {
    result = axios.get('promotion-scenario/' + id, { headers: headers });
  } else if (type == 'edit') {
    result = axios.put('promotion-scenario/' + data.ID, data, {
      headers: headers,
    });
  } else result = axios.post('promotion-scenario', data, { headers: headers });
  //}
  return result;
};
export const getPromoScenarioById = (data) => {
  return {
    type: SCENARIO_BY_ID,
    data,
  };
};
export const getSavedScenario = (data) => {
  return {
    type: SAVED_SCENARIO,
    data,
  };
};
// get api for scenario dropdown
export const getPrefillScenarioList = (data) => {
  return (dispatch) => {
    dispatch(fetchStart());
    dispatch(CostingSimulationStart());
    getPrefillScenarioListApi(data)
      .then((response) => {
        dispatch(fetchEnd());
        dispatch(CostingSimulationEnd());
        dispatch(getPrefillScenarioListSuccess(response.data.response));
        // history.push({ pathname: "/promotion-scenario-setup" });
      })
      .catch((error) => {
        dispatch(CostingSimulationEnd());
        dispatch(fetchEnd());
        //toast.error(error.response.data.error.message);
      });
  };
};

const getPrefillScenarioListApi = (data) => {
  const headers = {
    Authorization: secureLocalStorage.getItem('aTk'),
  };
  var result;
  result = axios.post('promotion-define-market', data, { headers: headers });
  return result;
};

export const getPrefillScenarioListSuccess = (data) => {
  return {
    type: PREFILL_SCENARIO_SUCCESS,
    data,
  };
};

//get material pricing table data

export const getMaterialPricingData = () => {
  return (dispatch) => {
    dispatch(fetchStart());
    getMaterialPricingDataApi()
      .then((response) => {
        dispatch(fetchEnd());
        dispatch(getMaterialPricingDataSuccess(response.data.response));
        console.log(response);
      })
      .catch((error) => {
        dispatch(fetchEnd());
      });
  };
};
const getMaterialPricingDataApi = () => {
  const headers = {
    Authorization: secureLocalStorage.getItem('aTk'),
  };
  var result;
  result = axios.get('material-pricing?page=1&&limit=0', { headers: headers });
  return result;
};

export const getMaterialPricingDataSuccess = (data) => {
  return {
    type: MATERIAL_PRICING_DATA_SUCCESS,
    data,
  };
};

//get material pricing table data

export const getSingleMaterialPricingData = (id) => {
  return (dispatch) => {
    getSingleMaterialPricingDataApi(id)
      .then((response) => {
        dispatch(getSingleMaterialPricingDataSuccess(response.data.response));
      })
      .catch((error) => { });
  };
};
const getSingleMaterialPricingDataApi = (id) => {
  const headers = {
    Authorization: secureLocalStorage.getItem('aTk'),
  };
  var result;
  result = axios.get('material-pricing/' + id, { headers: headers });
  return result;
};

export const getSingleMaterialPricingDataSuccess = (data) => {
  return {
    type: MATERIAL_PRICING_SINGLE_DATA_SUCCESS,
    data,
  };
};

//edit page material pricing table data

export const putMaterialPricingData = (data, id) => {
  return (dispatch) => {
    dispatch(fetchStart());
    putMaterialPricingDataApi(data, id)
      .then((response) => {
        dispatch(fetchEnd());
        toast.success(response.data.response);
        const formData = sessionStorage.getItem('search-data') ? JSON.parse(sessionStorage.getItem('search-data')) : {};
        dispatch(getPromotionsSearch(1, 0, 'search', formData, 'promotion_material_pricings'));
        history.push({
          pathname: '/material-pricing',
          state: 'MaterialPricing',
        });
      })
      .catch((error) => {
        dispatch(fetchEnd());
      });
  };
};

const putMaterialPricingDataApi = (data, id) => {
  const headers = {
    Authorization: secureLocalStorage.getItem('aTk'),
  };
  var result;
  result = axios.put('update-material-pricing/' + id, data, {
    headers: headers,
  });
  return result;
};

//delete material pricing table data

export const deleteMaterialPricingData = (id) => {
  return (dispatch) => {
    dispatch(fetchStart());
    deleteMaterialPricingDataApi(id).then((response) => {
      dispatch(fetchEnd());
      toast.success(response.data.response);
      const formData = sessionStorage.getItem('search-data') ? JSON.parse(sessionStorage.getItem('search-data')) : {};
      dispatch(getPromotionsSearch(1, 0, 'search', formData, 'promotion_material_pricings'));
    })
      .catch((error) => {
        dispatch(fetchEnd());
      });
  };
};
const deleteMaterialPricingDataApi = (id) => {
  const headers = {
    Authorization: secureLocalStorage.getItem('aTk'),
  };
  var result;
  result = axios.delete('material-pricing/' + id, { headers: headers });
  return result;
};

//

export const getPromotionsSearch = (
  pagination,
  limit,
  keyword,
  data,
  table,
) => {
  return (dispatch) => {
    dispatch(fetchStart());
    getPromotionsSearchApi(pagination, limit, keyword, data, table)
      .then((response) => {
        if (keyword === 'search') {
          dispatch(fetchEnd());
          dispatch(getPromotionsSearchSuccess(response.data.response));
          if (table === 'sales_forecast_data')
            history.push({
              pathname: '/sales-forecast-main',
              state: 'SalesForecast',
            });
          else if (table === 'promotion_budget_sales_forecast_data')
            history.push({
              pathname: '/budget-forecast-main',
              state: 'BudgetSalesForecast',
            });
          else if (table === 'promotion_material_pricings')
            history.push({
              pathname: '/material-pricing',
              state: 'MaterialPricing',
            });
          else if (table === 'coverage_cost_mappings')
            history.push({
              pathname: '/coverage-cost-mapping',
              state: 'CoverageCostMapping',
            });
          else if (table === 'promotion_material_master')
            history.push({
              pathname: '/material-master-promo',
              state: 'displayAPICALL',
            });
          else
            history.push({ pathname: '/coverage-cost', state: 'CoverageCost' });
        } else {
          dispatch(fetchEnd());
          dispatch(getPromotionsSearchSuccess(response.data.response));
        }
      })
      .catch((error) => {
        dispatch(fetchEnd());
      });
  };
};

const getPromotionsSearchApi = (pagination, limit, keyword, data, table) => {
  if (keyword === 'search') {
    for (var propName in data) {
      if (
        data[propName] === '' ||
        data[propName] === null ||
        data[propName] === undefined ||
        data[propName].length === 0 ||
        data[propName] ===
        '1970-01-01T00:00:00.000Z,1970-01-01T00:00:00.000Z' ||
        data[propName] === '1970-01-01T00:00:00.000Z' ||
        data[propName] === ','
      ) {
        delete data[propName];
      }
    }
  }
  const headers = {
    Authorization: secureLocalStorage.getItem('aTk'),
  };
  var result;
  if (keyword === 'search') {
    result = axios.post(
      'promotions-search?page=' +
      pagination +
      '&limit=' +
      0 +
      '&table_name=' +
      table,
      data,
      { headers: headers },
    );
  } else {
    if (pagination === 'NoLimit') {
      result = axios.get('promotions-search?limit=0', { headers: headers });
    } else {
      result = axios.get(
        'promotions-search?page=' + pagination + '&limit=' + limit,
        { headers: headers },
      );
    }
  }
  return result;
};

export const getPromotionsSearchSuccess = (data) => {
  return {
    type: PROMOTIONS_SEARCH_SUCCESS,
    data,
  };
};

//get promotion config data

export const getSinglePromotionConfigData = (id) => {
  return (dispatch) => {
    getSinglePromotionConfigDataApi(id)
      .then((response) => {
        dispatch(getSinglePromotionConfigDataSuccess(response.data.response));
      })
      .catch((error) => { });
  };
};
const getSinglePromotionConfigDataApi = (id) => {
  const headers = {
    Authorization: secureLocalStorage.getItem('aTk'),
  };
  var result;
  result = axios.get('promotion-config/' + id, { headers: headers });
  return result;
};

export const getSinglePromotionConfigDataSuccess = (data) => {
  return {
    type: PROMO_CONFIG_SINGLE_DATA_SUCCESS,
    data,
  };
};

//edit page promotion config table data

export const putPromotionConfigData = (data, id) => {
  return (dispatch) => {
    putPromotionConfigDataApi(data, id)
      .then((response) => {
        toast.success(response.data.response);
        history.push('/promo-config');
      })
      .catch((error) => {
      });
  };
};

const putPromotionConfigDataApi = (data, id) => {
  const headers = {
    Authorization: secureLocalStorage.getItem('aTk'),
  };
  var result;
  result = axios.put('promotion-config/' + id, data, { headers: headers });
  return result;
};

//get scenario list table data

export const getScenarioList = (productLine, data) => {
  return (dispatch) => {
    dispatch(fetchStart());
    getScenarioListApi(productLine, data)
      .then((response) => {
        dispatch(fetchEnd());
        dispatch(getScenarioListSuccess(response.data.response));
      })
      .catch((error) => {
        dispatch(fetchEnd());
      });
  };
};
const getScenarioListApi = (productLine, data) => {
  const headers = {
    Authorization: secureLocalStorage.getItem('aTk'),
  };
  var result;
  if (data) {
    result = axios.get(
      'promotion/scenario-list?',
      { params: data, headers: headers },
    );
  } else
    result = axios.get('promotion/scenario-list?product_lines=' + productLine, {
      headers: headers,
    });
  return result;
};

export const getScenarioListSuccess = (data) => {
  return {
    type: SCENARIO_LIST_DATA_SUCCESS,
    data,
  };
};

// scenario list actions buttons

export const createScenarioList = (data, type, value, fieldName) => {
  return (dispatch) => {
    dispatch(fetchStart());
    createScenarioListAPI(data, type, value, fieldName)
      .then((response) => {
        dispatch(fetchEnd());
        if (['clone', 'extended_scenario', 'premature_scenario'].includes(type)) {
          if (response.data.response?.response)
            toast.success(response.data.response?.response)
          if (response.data.response?.warning_message)
            toast.warning(response.data.response?.warning_message)
        }
        else
          toast.success(response.data.response);

        // history.push("/promotion-scenario-list");
        if (fieldName === 'Archived') {
          dispatch(getScenarioList(value.product_line, {
            product_lines: value.product_line,
            archived: true
          }));
        }
        else if (['delete', 'clone', 'extended_scenario', 'premature_scenario'].includes(type)) {
          // console.log(value.product_line[0])
          dispatch(getScenarioList(value.product_line));
        }
      })
      .catch((error) => {
        dispatch(fetchEnd());
      });
  };
};

const createScenarioListAPI = (data, type, value, fieldName) => {
  const headers = {
    Authorization: secureLocalStorage.getItem('aTk'),
  };
  var result;
  if (['clone', 'extended_scenario', 'premature_scenario'].includes(type))
    result = axios.post('promotion/scenario/' + type, data, {
      headers: headers,
    });
  else if (type === 'delete')
    result = axios.delete('promotion/scenario/' + value.ID, {
      headers: headers,
    });
  // else if (type === 'clone')
  //   result = axios.post("promotion/scenario/clone", data, {
  //     headers: headers,
  //   });
  // else
  //   result = axios.put("/promotion-scenario/" + value.ID, data, {
  //     headers: headers,
  //   });
  return result;
};

//coverage cost mapping

// add edit coverage cost mapping
export const addCoverageMappingFormatData = (data, id) => {
  return (dispatch) => {
    dispatch(fetchStart());
    addCoverageMappingFormatDataApi(data, id)
      .then((response) => {
        toast.success(response.data.response);
        dispatch(fetchEnd());
        history.push('/coverage-cost-mapping/excel-upload');
      })
      .catch((error) => {
        dispatch(fetchEnd());
        //toast.error(error.response.data.error.message);
      });
  };
};

const addCoverageMappingFormatDataApi = (data, id) => {
  const headers = {
    Authorization: secureLocalStorage.getItem('aTk'),
  };
  var result;
  if (id) {
    result = axios.put(
      'upload-format/' +
      id +
      '?app-functionality=PromotionCoverageCostMappingsFormat',
      data,
      { headers: headers },
    );
  } else {
    result = axios.post(
      'upload-format?app-functionality=PromotionCoverageCostMappingsFormat',
      data,
      { headers: headers },
    );
  }
  return result;
};

// delete coverage cost mapping

export const deleteCoverageMappingFormatData = (id) => {
  return (dispatch) => {
    dispatch(fetchStart());
    deleteCoverageMappingFormatDataApi(id)
      .then((response) => {
        dispatch(fetchEnd());
        if (response.status === 201 || response.status === 200) {
          toast.success(response.data.response);
          dispatch(getCoverageMappingFormatData());
        } else {
          //toast.error(response.data.error.message);
        }
      })
      .catch((error) => {
        dispatch(fetchEnd());
        //toast.error(error.response.data.error.message);
      });
  };
};

const deleteCoverageMappingFormatDataApi = (id) => {
  const headers = {
    Authorization: secureLocalStorage.getItem('aTk'),
  };
  var result;
  result = axios.delete('upload-format/' + id, { headers: headers });
  return result;
};

//upload coverage cost mapping data file

export const uploadCoverageMappingDataFile = (id, file) => {
  return (dispatch) => {
    dispatch(fetchStart());
    uploadCoverageMappingDataFileApi(id, file)
      .then((response) => {
        if (response.status === 201 || response.status === 200) {
          dispatch(fetchEnd());
          dispatch(uploadCoverageMappingSuccess(response.data.response));
          if (
            response.data.response &&
            response.data.response.error_list == null
          ) {
            toast.success(response.data.response.success_msg);
          }
        } else {
          //toast.error(response.data.complete_error_message);
        }
      })
      .catch((error) => {
        dispatch(fetchEnd());
        //toast.error(error.response.data.complete_error_message);
      });
  };
};
const uploadCoverageMappingDataFileApi = (id, file) => {
  const headers = {
    Authorization: secureLocalStorage.getItem('aTk'),
    'Content-Type': 'multipart/form-data;',
  };
  var result;
  result = axios.post('upload-file?format_id=' + id, file, {
    headers: headers,
  });
  return result;
};

export const uploadCoverageMappingSuccess = (data) => {
  return {
    type: COVERAGE_MAPPING_UPLOAD_SUCCESS,
    data,
  };
};

//get Coverage Cost Mapping format fields

export const getCoverageMappingFormatFields = () => {
  return (dispatch) => {
    getCoverageMappingFormatFieldsApi()
      .then((response) => {
        dispatch(getCoverageMappingFormatFieldsSuccess(response.data.response));
      })
      .catch((error) => {
        //toast.error(error.response.data.error.message);
      });
  };
};

const getCoverageMappingFormatFieldsApi = () => {
  const headers = {
    Authorization: secureLocalStorage.getItem('aTk'),
  };
  var result;
  result = axios.get(
    'upload-format-fields?app-functionality=PromotionCoverageCostMappingsFormat',
    { headers: headers },
  );
  return result;
};

export const getCoverageMappingFormatFieldsSuccess = (data) => {
  return {
    type: COVERAGE_MAPPING_FORMAT_FIELDS_SUCCESS,
    data,
  };
};

//get Coverage Cost Mapping format data

export const getCoverageMappingFormatData = () => {
  return (dispatch) => {
    getCoverageMappingFormatDataApi()
      .then((response) => {
        dispatch(getCoverageMappingFormatDataSuccess(response.data.response));
      })
      .catch((error) => {
        //toast.error(error.response.data.error.message);
      });
  };
};

const getCoverageMappingFormatDataApi = () => {
  const headers = {
    Authorization: secureLocalStorage.getItem('aTk'),
  };
  var result;
  result = axios.get(
    'upload-format?app-functionality=PromotionCoverageCostMappingsFormat',
    { headers: headers },
  );
  return result;
};

export const getCoverageMappingFormatDataSuccess = (data) => {
  return {
    type: COVERAGE_MAPPING_FORMAT_SUCCESS,
    data,
  };
};

//delete coverage mapping table data

export const deleteCoverageMappingData = (id) => {
  return (dispatch) => {
    deleteCoverageMappingDataApi(id).then((response) => {
      toast.success(response.data.response);
      dispatch(getCoverageMappingData());
    });
  };
};
const deleteCoverageMappingDataApi = (id) => {
  const headers = {
    Authorization: secureLocalStorage.getItem('aTk'),
  };
  var result;
  result = axios.delete('coverage-cost-mapping/' + id, { headers: headers });
  return result;
};

//get Coverage cost mapping table data

export const getCoverageMappingData = () => {
  return (dispatch) => {
    dispatch(fetchStart());
    getCoverageMappingDataApi()
      .then((response) => {
        dispatch(fetchEnd());
        dispatch(getCoverageMappingDataSuccess(response.data.response));
      })
      .catch((error) => {
        dispatch(fetchEnd());
      });
  };
};
const getCoverageMappingDataApi = () => {
  const headers = {
    Authorization: secureLocalStorage.getItem('aTk'),
  };
  var result;
  result = axios.get('coverage-cost-mapping?page=1&&limit=0', {
    headers: headers,
  });
  return result;
};

export const getCoverageMappingDataSuccess = (data) => {
  return {
    type: COVERAGE_MAPPING_DATA_SUCCESS,
    data,
  };
};

// get single data for Coverage cost mapping

export const getCoverageMappingSingleItem = (id) => {
  return (dispatch) => {
    getCoverageMappingSingleItemAPI(id).then((response) => {
      dispatch(getCoverageMappingSingleItemSuccess(response.data.response));
    });
  };
};
const getCoverageMappingSingleItemAPI = (id) => {
  const headers = {
    Authorization: secureLocalStorage.getItem('aTk'),
  };
  var result;
  result = axios.get('coverage-cost-mapping/' + id, { headers: headers });
  return result;
};

export const getCoverageMappingSingleItemSuccess = (data) => {
  return {
    type: COVERAGE_MAPPING_SINGLE_SUCCESS,
    data,
  };
};

//edit page  Coverage cost mapping table data

export const updateCoverageMappingData = (data, id) => {
  return (dispatch) => {
    updateCoverageMappingDataApi(data, id)
      .then((response) => {
        toast.success(response.data.response);
        history.push('/coverage-cost-mapping');
      })
      .catch((error) => {
      });
  };
};

const updateCoverageMappingDataApi = (data, id) => {
  const headers = {
    Authorization: secureLocalStorage.getItem('aTk'),
  };
  var result;
  result = axios.put('update-coverage-cost-mapping/' + id, data, {
    headers: headers,
  });
  return result;
};

//Standard Finance cost

// add edit Standard Finance Cost
export const addStandardFinanceFormatData = (data, id) => {
  return (dispatch) => {
    dispatch(fetchStart());
    addStandardFinanceFormatDataApi(data, id)
      .then((response) => {
        toast.success(response.data.response);
        dispatch(fetchEnd());
        history.push('/standard-finance-cost/excel-upload');
      })
      .catch((error) => {
        dispatch(fetchEnd());
        //toast.error(error.response.data.error.message);
      });
  };
};

const addStandardFinanceFormatDataApi = (data, id) => {
  const headers = {
    Authorization: secureLocalStorage.getItem('aTk'),
  };
  var result;
  if (id) {
    result = axios.put(
      'upload-format/' +
      id +
      '?app-functionality=PromotionStandardFinanceCostsFormat',
      data,
      { headers: headers },
    );
  } else {
    result = axios.post(
      'upload-format?app-functionality=PromotionStandardFinanceCostsFormat',
      data,
      { headers: headers },
    );
  }
  return result;
};

// delete Standard Finance Cost

export const deleteStandardFinanceFormatData = (id) => {
  return (dispatch) => {
    dispatch(fetchStart());
    deleteStandardFinanceFormatDataApi(id)
      .then((response) => {
        dispatch(fetchEnd());
        if (response.status === 201 || response.status === 200) {
          toast.success(response.data.response);
          dispatch(getStandardFinanceFormatData());
        } else {
          //toast.error(response.data.error.message);
        }
      })
      .catch((error) => {
        dispatch(fetchEnd());
        //toast.error(error.response.data.error.message);
      });
  };
};

const deleteStandardFinanceFormatDataApi = (id) => {
  const headers = {
    Authorization: secureLocalStorage.getItem('aTk'),
  };
  var result;
  result = axios.delete('upload-format/' + id, { headers: headers });
  return result;
};

//upload Standard Finance Cost data file

export const uploadStandardFinanceDataFile = (id, file) => {
  return (dispatch) => {
    dispatch(fetchStart());
    uploadStandardFinanceDataFileApi(id, file)
      .then((response) => {
        if (response.status === 201 || response.status === 200) {
          dispatch(fetchEnd());
          dispatch(uploadStandardFinanceSuccess(response.data.response));
          if (
            response.data.response &&
            response.data.response.success_msg
          ) {
            toast.success(response.data.response.success_msg);
          }
          if (response.data.response?.warning_msg)
            toast.warning('We have some warnings, please check Data log.')
        } else {
          //toast.error(response.data.complete_error_message);
        }
      })
      .catch((error) => {
        dispatch(fetchEnd());
        //toast.error(error.response.data.complete_error_message);
      });
  };
};
const uploadStandardFinanceDataFileApi = (id, file) => {
  const headers = {
    Authorization: secureLocalStorage.getItem('aTk'),
    'Content-Type': 'multipart/form-data;',
  };
  var result;
  result = axios.post('upload-file?format_id=' + id, file, {
    headers: headers,
  });
  return result;
};

export const uploadStandardFinanceSuccess = (data) => {
  return {
    type: STANDARD_FINANCE_UPLOAD_SUCCESS,
    data,
  };
};

//get Standard Finance Cost format fields

export const getStandardFinanceFormatFields = () => {
  return (dispatch) => {
    getStandardFinanceFormatFieldsApi()
      .then((response) => {
        dispatch(getStandardFinanceFormatFieldsSuccess(response.data.response));
      })
      .catch((error) => {
        //toast.error(error.response.data.error.message);
      });
  };
};

const getStandardFinanceFormatFieldsApi = () => {
  const headers = {
    Authorization: secureLocalStorage.getItem('aTk'),
  };
  var result;
  result = axios.get(
    'upload-format-fields?app-functionality=PromotionStandardFinanceCostsFormat',
    { headers: headers },
  );
  return result;
};

export const getStandardFinanceFormatFieldsSuccess = (data) => {
  return {
    type: STANDARD_FINANCE_FORMAT_FIELDS_SUCCESS,
    data,
  };
};

//get Standard Finance Cost format data

export const getStandardFinanceFormatData = () => {
  return (dispatch) => {
    getStandardFinanceFormatDataApi()
      .then((response) => {
        dispatch(getStandardFinanceFormatDataSuccess(response.data.response));
      })
      .catch((error) => {
        //toast.error(error.response.data.error.message);
      });
  };
};

const getStandardFinanceFormatDataApi = () => {
  const headers = {
    Authorization: secureLocalStorage.getItem('aTk'),
  };
  var result;
  result = axios.get(
    'upload-format?app-functionality=PromotionStandardFinanceCostsFormat',
    { headers: headers },
  );
  return result;
};

export const getStandardFinanceFormatDataSuccess = (data) => {
  return {
    type: STANDARD_FINANCE_FORMAT_SUCCESS,
    data,
  };
};

//get Standard Finance Cost table data

export const getStandardFinanceData = () => {
  return (dispatch) => {
    dispatch(fetchStart());
    getStandardFinanceDataApi()
      .then((response) => {
        dispatch(fetchEnd());
        dispatch(getStandardFinanceDataSuccess(response.data.response));
        console.log(response);
      })
      .catch((error) => {
        dispatch(fetchEnd());
      });
  };
};
const getStandardFinanceDataApi = () => {
  const headers = {
    Authorization: secureLocalStorage.getItem('aTk'),
  };
  var result;
  result = axios.get('promotion-finances?page=1&&limit=0', {
    headers: headers,
  });
  return result;
};

export const getStandardFinanceDataSuccess = (data) => {
  return {
    type: STANDARD_FINANCE_DATA_SUCCESS,
    data,
  };
};

//delete Standard Finance Cost table data

export const deleteStandardFinanceData = (id) => {
  return (dispatch) => {
    deleteStandardFinanceDataApi(id).then((response) => {
      toast.success(response.data.response);
      dispatch(getStandardFinanceData());
    });
  };
};
const deleteStandardFinanceDataApi = (id) => {
  const headers = {
    Authorization: secureLocalStorage.getItem('aTk'),
  };
  var result;
  result = axios.delete('promotion-finance/' + id, { headers: headers });
  return result;
};

//get single standard finance table data

export const getSingleStandardFinanceData = (id) => {
  return (dispatch) => {
    getSingleStandardFinanceDataApi(id)
      .then((response) => {
        dispatch(getSingleStandardFinanceDataSuccess(response.data.response));
      })
      .catch((error) => { });
  };
};
const getSingleStandardFinanceDataApi = (id) => {
  const headers = {
    Authorization: secureLocalStorage.getItem('aTk'),
  };
  var result;
  result = axios.get('promotion-finance/' + id, { headers: headers });
  return result;
};

export const getSingleStandardFinanceDataSuccess = (data) => {
  return {
    type: STANDARD_FINANCE_SINGLE_DATA_SUCCESS,
    data,
  };
};

//edit page standard finance table data

export const updateStandardFinanceData = (data, id) => {
  return (dispatch) => {
    updateStandardFinanceDataApi(data, id)
      .then((response) => {
        toast.success(response.data.response);
        history.push('/standard-finance-cost');
      })
      .catch((error) => {
      });
  };
};

const updateStandardFinanceDataApi = (data, id) => {
  const headers = {
    Authorization: secureLocalStorage.getItem('aTk'),
  };
  var result;
  result = axios.put('update-promotion-finance/' + id, data, {
    headers: headers,
  });
  return result;
};

// Promotion Currency Rates

// add edit  Promotion Currency Rates
export const addPromotionCurrencyFormatData = (data, id) => {
  return (dispatch) => {
    dispatch(fetchStart());
    addPromotionCurrencyFormatDataApi(data, id)
      .then((response) => {
        toast.success(response.data.response);
        dispatch(fetchEnd());
        history.push('/promo-currency/excel-upload');
      })
      .catch((error) => {
        dispatch(fetchEnd());
        //toast.error(error.response.data.error.message);
      });
  };
};

const addPromotionCurrencyFormatDataApi = (data, id) => {
  const headers = {
    Authorization: secureLocalStorage.getItem('aTk'),
  };
  var result;
  if (id) {
    result = axios.put(
      'upload-format/' + id + '?app-functionality=PromotionCurrencyRatesFormat',
      data,
      { headers: headers },
    );
  } else {
    result = axios.post(
      'upload-format?app-functionality=PromotionCurrencyRatesFormat',
      data,
      { headers: headers },
    );
  }
  return result;
};

// delete Promotion Currency Rates

export const deletePromotionCurrencyFormatData = (id) => {
  return (dispatch) => {
    dispatch(fetchStart());
    deletePromotionCurrencyFormatDataApi(id)
      .then((response) => {
        dispatch(fetchEnd());
        if (response.status === 201 || response.status === 200) {
          toast.success(response.data.response);
          dispatch(getPromotionCurrencyFormatData());
        } else {
          //toast.error(response.data.error.message);
        }
      })
      .catch((error) => {
        dispatch(fetchEnd());
        //toast.error(error.response.data.error.message);
      });
  };
};

const deletePromotionCurrencyFormatDataApi = (id) => {
  const headers = {
    Authorization: secureLocalStorage.getItem('aTk'),
  };
  var result;
  result = axios.delete('upload-format/' + id, { headers: headers });
  return result;
};

//upload Promotion Currency Rates data file

export const uploadPromotionCurrencyDataFile = (id, file) => {
  return (dispatch) => {
    dispatch(fetchStart());
    uploadPromotionCurrencyDataFileApi(id, file)
      .then((response) => {
        if (response.status === 201 || response.status === 200) {
          dispatch(fetchEnd());
          dispatch(uploadPromotionCurrencySuccess(response.data.response));
          if (
            response.data.response &&
            response.data.response.success_msg
          ) {
            toast.success(response.data.response.success_msg);
          }
          if (response.data.response?.warning_msg)
            toast.warning('We have some warnings, please check Data log.')
        } else {
          //toast.error(response.data.complete_error_message);
        }
      })
      .catch((error) => {
        dispatch(fetchEnd());
        //toast.error(error.response.data.complete_error_message);
      });
  };
};
const uploadPromotionCurrencyDataFileApi = (id, file) => {
  const headers = {
    Authorization: secureLocalStorage.getItem('aTk'),
    'Content-Type': 'multipart/form-data;',
  };
  var result;
  result = axios.post('upload-file?format_id=' + id, file, {
    headers: headers,
  });
  return result;
};

export const uploadPromotionCurrencySuccess = (data) => {
  return {
    type: PROMOTION_CURRENCY_UPLOAD_SUCCESS,
    data,
  };
};

//get Promotion Currency Rates format fields

export const getPromotionCurrencyFormatFields = () => {
  return (dispatch) => {
    getPromotionCurrencyFormatFieldsApi()
      .then((response) => {
        dispatch(
          getPromotionCurrencyFormatFieldsSuccess(response.data.response),
        );
      })
      .catch((error) => {
        //toast.error(error.response.data.error.message);
      });
  };
};

const getPromotionCurrencyFormatFieldsApi = () => {
  const headers = {
    Authorization: secureLocalStorage.getItem('aTk'),
  };
  var result;
  result = axios.get(
    'upload-format-fields?app-functionality=PromotionCurrencyRatesFormat',
    { headers: headers },
  );
  return result;
};

export const getPromotionCurrencyFormatFieldsSuccess = (data) => {
  return {
    type: PROMOTION_CURRENCY_FORMAT_FIELDS_SUCCESS,
    data,
  };
};

//get Promotion Currency Rates format data

export const getPromotionCurrencyFormatData = () => {
  return (dispatch) => {
    getPromotionCurrencyFormatDataApi()
      .then((response) => {
        dispatch(getPromotionCurrencyFormatDataSuccess(response.data.response));
      })
      .catch((error) => {
        //toast.error(error.response.data.error.message);
      });
  };
};

const getPromotionCurrencyFormatDataApi = () => {
  const headers = {
    Authorization: secureLocalStorage.getItem('aTk'),
  };
  var result;
  result = axios.get(
    'upload-format?app-functionality=PromotionCurrencyRatesFormat',
    { headers: headers },
  );
  return result;
};

export const getPromotionCurrencyFormatDataSuccess = (data) => {
  return {
    type: PROMOTION_CURRENCY_FORMAT_SUCCESS,
    data,
  };
};

//get Promotion Currency Rates table data

export const getPromotionCurrencyData = () => {
  return (dispatch) => {
    dispatch(fetchStart());
    getPromotionCurrencyDataApi()
      .then((response) => {
        dispatch(fetchEnd());
        dispatch(getPromotionCurrencyDataSuccess(response.data.response));
        console.log(response);
      })
      .catch((error) => {
        dispatch(fetchEnd());
      });
  };
};
const getPromotionCurrencyDataApi = () => {
  const headers = {
    Authorization: secureLocalStorage.getItem('aTk'),
  };
  var result;
  result = axios.get('promo-currency-rates?page=1&&limit=0', {
    headers: headers,
  });
  return result;
};

export const getPromotionCurrencyDataSuccess = (data) => {
  return {
    type: PROMOTION_CURRENCY_DATA_SUCCESS,
    data,
  };
};

//delete Promotion Currency Rates table data

export const deletePromotionCurrencyData = (id) => {
  return (dispatch) => {
    deletePromotionCurrencyDataApi(id).then((response) => {
      toast.success(response.data.response);
      dispatch(getPromotionCurrencyData());
    });
  };
};
const deletePromotionCurrencyDataApi = (id) => {
  const headers = {
    Authorization: secureLocalStorage.getItem('aTk'),
  };
  var result;
  result = axios.delete('promo-currency-rate/' + id, { headers: headers });
  return result;
};

// get single data for Promotion Currency Rates

export const getPromotionCurrencySingleItem = (id) => {
  return (dispatch) => {
    getPromotionCurrencySingleItemAPI(id).then((response) => {
      dispatch(getPromotionCurrencySingleItemSuccess(response.data.response));
    });
  };
};
const getPromotionCurrencySingleItemAPI = (id) => {
  const headers = {
    Authorization: secureLocalStorage.getItem('aTk'),
  };
  var result;
  result = axios.get('promo-currency-rate/' + id, { headers: headers });
  return result;
};

export const getPromotionCurrencySingleItemSuccess = (data) => {
  return {
    type: PROMOTION_CURRENCY_SINGLE_SUCCESS,
    data,
  };
};

//edit page Promotion Currency table data

export const updatePromotionCurrencyData = (data, id) => {
  return (dispatch) => {
    updatePromotionCurrencyDataApi(data, id)
      .then((response) => {
        toast.success(response.data.response);
        history.push('/promo-currency');
      })
      .catch((error) => {
      });
  };
};

const updatePromotionCurrencyDataApi = (data, id) => {
  const headers = {
    Authorization: secureLocalStorage.getItem('aTk'),
  };
  var result;
  result = axios.put('update-promo-currency-rate/' + id, data, {
    headers: headers,
  });
  return result;
};

//get Finance group rate single table data
export const updateFinanceGroupRatesData = (data, id) => {
  return (dispatch) => {
    updateFinanceGroupRatesDataApi(data, id)
      .then((response) => {
        toast.success(response.data.response);
        history.push('/finance-group-rates');
      })
      .catch((error) => {
      });
  };
};

const updateFinanceGroupRatesDataApi = (data, id) => {
  const headers = {
    Authorization: secureLocalStorage.getItem('aTk'),
  };
  var result;
  result = axios.put('promotion/pf-anchor-rates/' + id, data, { headers: headers });
  return result;
};

//get Finance term split single table data

export const updateFinanceTermSplitData = (data, id) => {
  return (dispatch) => {
    updateFinanceTermSplitDataApi(data, id)
      .then((response) => {
        toast.success(response.data.response);
        history.push('/finance-term-split');
      })
      .catch((error) => {
      });
  };
};

const updateFinanceTermSplitDataApi = (data, id) => {
  const headers = {
    Authorization: secureLocalStorage.getItem('aTk'),
  };
  var result;
  result = axios.put('promotion/pf-anchor-splits/' + id, data, { headers: headers });
  return result;
};

//edit Finance Cost table single data

export const updateFinanceCostData = (data, id) => {
  return (dispatch) => {
    updateFinanceCostDataApi(data, id)
      .then((response) => {
        toast.success(response.data.response);
        history.push('/finance-cost');
      })
      .catch((error) => {
      });
  };
};

const updateFinanceCostDataApi = (data, id) => {
  const headers = {
    Authorization: secureLocalStorage.getItem('aTk'),
  };
  var result;
  result = axios.put('update-finance-cost/' + id, data, { headers: headers });
  return result;
};

// edit Promotion territory single data

export const updatePromotionTerritoryData = (data, id) => {
  return (dispatch) => {
    updatePromotionTerritoryDataApi(data, id)
      .then((response) => {
        toast.success(response.data.response);
        history.push('/promotion-territory');
      })
      .catch((error) => {
      });
  };
};

const updatePromotionTerritoryDataApi = (data, id) => {
  const headers = {
    Authorization: secureLocalStorage.getItem('aTk'),
  };
  var result;
  result = axios.put('update-promo-territory/' + id, data, {
    headers: headers,
  });
  return result;
};

//get sales forecast single table data

export const getSingleSalesForecastData = (id) => {
  return (dispatch) => {
    getSingleSalesForecastDataApi(id)
      .then((response) => {
        dispatch(getSingleSalesForecastDataSuccess(response.data.response));
      })
      .catch((error) => { });
  };
};
const getSingleSalesForecastDataApi = (id) => {
  const headers = {
    Authorization: secureLocalStorage.getItem('aTk'),
  };
  var result;
  result = axios.get('sales-forecast/' + id, { headers: headers });
  return result;
};

export const getSingleSalesForecastDataSuccess = (data) => {
  return {
    type: SALES_FORECAST_SINGLE_DATA_SUCCESS,
    data,
  };
};

//edit page sales forecast table data

export const updateSalesForecastData = (data, id) => {
  return (dispatch) => {
    updateSalesForecastDataApi(data, id).then((response) => {
      // toast.success("Successfully updated.");
      toast.success(response.data.response);
      dispatch(
        getPromotionsSearch(
          1,
          0,
          'search',
          JSON.parse(sessionStorage.getItem('search-data')),
          'sales_forecast_data',
        ),
      );
    });
  };
};

const updateSalesForecastDataApi = (data, id) => {
  const headers = {
    Authorization: secureLocalStorage.getItem('aTk'),
  };
  var result;
  result = axios.put('update-sales-forecast/' + id, data, { headers: headers });
  return result;
};

//delete sales forecast table data

export const deleteSalesForecastData = (id) => {
  return (dispatch) => {
    deleteSalesForecastDataApi(id).then((response) => {
      toast.success(response.data.response);
      dispatch(
        getPromotionsSearch(
          1,
          0,
          'search',
          JSON.parse(sessionStorage.getItem('search-data')),
          'sales_forecast_data',
        ),
      );
    });
  };
};
const deleteSalesForecastDataApi = (id) => {
  const headers = {
    Authorization: secureLocalStorage.getItem('aTk'),
  };
  var result;
  result = axios.delete('delete-sales-forecast/' + id, { headers: headers });
  return result;
};

//add promotion mapping single table data

export const addPromotionMappingData = (data) => {
  return (dispatch) => {
    addPromotionMappingDataApi(data)
      .then((response) => {
        toast.success(response.data.response);
        history.push('/promo-config');
      })
      .catch((error) => {
      });
  };
};

const addPromotionMappingDataApi = (data) => {
  const headers = {
    Authorization: secureLocalStorage.getItem('aTk'),
  };
  var result;
  result = axios.post('promo-config', data, { headers: headers });
  return result;
};
//review scenario-market
export const getScenarioMarkets = (data) => {
  return (dispatch) => {
    dispatch(CostingSimulationStart('market'));
    getScenarioMarketsApi(data)
      .then((response) => {
        dispatch(CostingSimulationEnd('market'));
        dispatch(getScenarioMarketsSuccess(response.data.response));
        // history.push({ pathname: "/promotion-scenario-setup" });
      })
      .catch((error) => {
        dispatch(CostingSimulationEnd('market'));
        //toast.error(error.response.data.error.message);
      });
  };
};

const getScenarioMarketsApi = (data) => {
  const headers = {
    Authorization: secureLocalStorage.getItem('aTk'),
  };
  var result;
  result = axios.post('promotion/review/markets', data, { headers: headers });
  // result = axios.post(
  //   "promotion/markets", data,
  //   { headers: headers }
  // );
  return result;
};

export const getScenarioMarketsSuccess = (data) => {
  return {
    type: SCENARIO_MARKETS,
    data,
  };
};
//validate-market
export const validateMarkets = (data, productLine) => {
  return (dispatch) => {
    dispatch(fetchStart);
    validateMarketsApi(data)
      .then((response) => {
        dispatch(fetchEnd());
        toast.success(response.data.response);
        var payload = {
          scenario_number: data.scenario_number,
          product_line: productLine,
        };
        dispatch(getScenarioMarkets(payload));
      })
      .catch((error) => {
        dispatch(fetchEnd());
      });
  };
};

const validateMarketsApi = (data) => {
  const headers = {
    Authorization: secureLocalStorage.getItem('aTk'),
  };
  var result;
  result = axios.put('promotion/review/market-status', data, {
    headers: headers,
  });
  // result = axios.put(
  //   "promotion/market-status", data,
  //   { headers: headers }
  // );
  return result;
};
//reviewSenario-previous scenario dropdown
export const getPreviousScenarioList = (data, type) => {
  return (dispatch) => {
    dispatch(CostingSimulationStart());
    getPreviousScenarioListApi(data, type)
      .then((response) => {
        dispatch(CostingSimulationEnd());
        if (type == 'approved')
          dispatch(getPreviousScenarioListSuccess(response.data.response));
        else dispatch(getCurrentScenariosSuccess(response.data.response));
        // history.push({ pathname: "/promotion-scenario-setup" });
      })
      .catch((error) => {
        dispatch(CostingSimulationEnd());
        //toast.error(error.response.data.error.message);
      });
  };
};

const getPreviousScenarioListApi = (data, type) => {
  const headers = {
    Authorization: secureLocalStorage.getItem('aTk'),
  };
  var result;
  result = axios.post('promotion/review/scenarios', data, { headers: headers });
  // if (type == 'Finance Team')
  //   result = axios.get(
  //     "promotion/market-scenarios?product_line=" + data,
  //     { headers: headers }
  //   );
  // else
  // result = axios.post(
  //   "promotion/scenario-dropdown", data,
  //   { headers: headers }
  // );
  return result;
};

export const getPreviousScenarioListSuccess = (data) => {
  return {
    type: PREVIOUS_SCENARIO,
    data,
  };
};
export const getCurrentScenariosSuccess = (data) => {
  return {
    type: CURRENT_SCENARIO,
    data,
  };
};
//reviewScenario-comparison
export const runScenarioComparison = (data) => {
  return (dispatch) => {
    dispatch(CostingSimulationStart());
    runScenarioComparisonApi(data)
      .then((response) => {
        dispatch(CostingSimulationEnd());
        dispatch(runScenarioComparisonSuccess(response.data.response));
        // history.push({ pathname: "/promotion-scenario-setup" });
      })
      .catch((error) => {
        dispatch(CostingSimulationEnd());
        //toast.error(error.response.data.error.message);
      });
  };
};

const runScenarioComparisonApi = (data) => {
  const headers = {
    Authorization: secureLocalStorage.getItem('aTk'),
  };
  var result;
  result = axios.post('promotion/review/market-stickers', data, {
    headers: headers,
  });
  // result = axios.post(
  //   "promotion/market-stickers", data,
  //   { headers: headers }
  // );
  return result;
};

export const runScenarioComparisonSuccess = (data) => {
  return {
    type: REVIEW_SCENARIO,
    data,
  };
};
//custom group
export const createCustomGroup = (data, id) => {
  return (dispatch) => {
    dispatch(fetchStart());
    createCustomGroupApi(data, id).then((response) => {
      dispatch(fetchEnd());
      toast.success(response.data.response);
      dispatch(getCustomGroups(null, data.product_line));
      history.push({
        pathname: '/custom-group',
        productLine: data.product_line,
        page: 'Custom Group',
      });
    });
  };
};

const createCustomGroupApi = (data, id) => {
  const headers = {
    Authorization: secureLocalStorage.getItem('aTk'),
  };
  var result;
  if (id)
    result = axios.put('promotion/custom-group/' + id, data, {
      headers: headers,
    });
  else
    result = axios.post('promotion/custom-group', data, { headers: headers });

  return result;
};
export const getCustomGroups = (id, productLine, type) => {
  return (dispatch) => {
    dispatch(fetchStart());
    dispatch(CostingSimulationStart());
    getCustomGroupsApi(id, productLine)
      .then((response) => {
        dispatch(fetchEnd());
        dispatch(CostingSimulationEnd());
        dispatch(getCustomGroupsSuccess(response.data.response, id));
        if (id && !Array.isArray(id)) {
          if (type === 'view')
            history.push({ pathname: '/view-custom-group/' + id });
          else
            history.push({ pathname: '/update-custom-group/' + id });
        }
      })
      .catch((error) => {
        dispatch(CostingSimulationEnd());
        //toast.error(error.response.data.error.message);
      });
  };
};

const getCustomGroupsApi = (id, productLine) => {
  const headers = {
    Authorization: secureLocalStorage.getItem('aTk'),
  };
  var result;
  if (id) {
    if (Array.isArray(id))
      result = axios.get('promotion/custom-groups?id.in=' + id, {
        headers: headers,
      });
    else
      result = axios.get('promotion/custom-group/' + id, { headers: headers });
  } else
    result = axios.get('promotion/custom-group?product_line=' + productLine, {
      headers: headers,
    });
  return result;
};

export const getCustomGroupsSuccess = (data, id) => {
  if (id) {
    if (Array.isArray(id))
      return {
        type: CUSTOM_GROUP_LIST,
        data,
      };
    else
      return {
        type: CUSTOM_GROUP_ID,
        data,
      };
  } else
    return {
      type: CUSTOM_GROUPS,
      data,
    };
};

//clone custom groups
export const cloneCustomGroups = (id, productLine) => {
  return (dispatch) => {
    dispatch(fetchStart());
    getCloneCustomGroupsApi(id)
      .then((response) => {
        dispatch(fetchEnd());
        toast.success(response.data.response);
        dispatch(getCustomGroups(null, productLine));
        history.push({
          pathname: '/custom-group',
          data: { productLine: productLine, page: 'clone' },
        });
      })
      .catch((error) => {
        dispatch(fetchEnd());
        // toast.error('Something went wrong.');
      });
  };
};

const getCloneCustomGroupsApi = (id) => {
  const headers = {
    Authorization: secureLocalStorage.getItem('aTk'),
  };
  var result;
  result = axios.post('promotion/custom-group/' + id + '/clone', {
    headers: headers,
  });
  return result;
};
//create archive
export const createArchive = (id, productline, tableName) => {
  return (dispatch) => {
    dispatch(fetchStart());
    getCreateArchiveApi(id, tableName)
      .then((response) => {
        dispatch(fetchEnd());
        toast.success(response.data.response);
        if (tableName === 'promotion_budget_and_forecasts')
          dispatch(getBudgetList(productline));
        else if (tableName === 'promotion_scenarios')
          dispatch(getScenarioList(productline));
        else
          dispatch(getCustomGroups(null, productline));
      })
      .catch((error) => {
        dispatch(fetchEnd());
        // toast.error('Something went wrong.');
      });
  };
};

const getCreateArchiveApi = (id, tableName) => {
  const headers = {
    Authorization: secureLocalStorage.getItem('aTk'),
  };
  var result;
  result = axios.put(
    'promotion/' + id + '/archive?table_name=' + tableName,
    {
      headers: headers,
    },
  );
  return result;
};
//archive list
export const getArchiveList = (productLine) => {
  return (dispatch) => {
    dispatch(fetchStart());
    dispatch(CostingSimulationStart());
    getArchiveListApi(productLine)
      .then((response) => {
        dispatch(fetchEnd());
        dispatch(CostingSimulationEnd());
        dispatch(getArchiveListSuccess(response.data.response));
      })
      .catch((error) => {
        dispatch(CostingSimulationEnd());
        //toast.error(error.response.data.error.message);
      });
  };
};

const getArchiveListApi = (productLine) => {
  const headers = {
    Authorization: secureLocalStorage.getItem('aTk'),
  };
  var result;

  result = axios.get(
    'promotion/custom-group?product_line=' + productLine + '&archive=true',
    { headers: headers },
  );

  return result;
};

export const getArchiveListSuccess = (data, id) => {
  return {
    type: ARCHIVE,
    data,
  };
};
export const runMultiPromoSearch = (data) => {
  return (dispatch) => {
    dispatch(fetchStart());
    runMultiPromoApi(data)
      .then((response) => {
        dispatch(fetchEnd());
        dispatch(runMultiPromoSearchSuccess(response.data.response));
        history.push('/promo-fin-exceptions-review');
      })
      .catch(() => {
        dispatch(fetchEnd());
        toast.error("Server Error");
      });
  };
};
const runMultiPromoApi = (data) => {
  const headers = {
    Authorization: secureLocalStorage.getItem("aTk"),
  };
  return axios.post("/promotion/stickers/multi-promo", data, { headers });
};
export const runMultiPromoSearchSuccess = (data) => {
  return {
    type: MULTI_PROMO_SEARCH_SUCCESS,
    data,
  };
};
export const getTRApprovalData = (productLine) => {
  return (dispatch) => {
    dispatch(fetchStart());
    getTRApprovalDataApi(productLine)
      .then((response) => {
        dispatch(fetchEnd());
        dispatch(getTRApprovalDataSuccess(response.data.response));
      })
      .catch((error) => {
        dispatch(fetchEnd());
      });
  };
};

const getTRApprovalDataApi = (productLine) => {
  const headers = {
    Authorization: secureLocalStorage.getItem('aTk'),
  };
  var result;
  result = axios.get(
    'promotion-tr-approval?product_line=' + productLine, /*+ '&country=' + country,*/
    {
      headers: headers,
    },
  );
  return result;
};

export const getTRApprovalDataSuccess = (data) => {
  return {
    type: TR_APPROVAL_DATA_SUCCESS,
    data,
  };
};

// //   Get TR Approval Review data
export const getTRApprovalReviewData = (data, type) => {
  return (dispatch) => {
    dispatch(fetchStart());
    getTRApprovalReviewDataApi(data, type)
      .then((response) => {
        dispatch(fetchEnd());
        dispatch(getTRApprovalReviewDataSuccess(response.data.response));
      })
      .catch((error) => {
        dispatch(fetchEnd());
        dispatch(getTRApprovalReviewDataSuccess({}));
      });
  };
};

const getTRApprovalReviewDataApi = (data) => {
  const headers = {
    Authorization: secureLocalStorage.getItem('aTk'),
  };
  var result;
  result = axios.post('promotion-tr-models', data, {
    headers: headers,
  });
  return result;
};

export const getTRApprovalReviewDataSuccess = (data) => {
  return {
    type: TR_APPROVAL_REVIEW_DATA_SUCCESS,
    data,
  };
};

export const getTRApprovalReviewCompletedDataSuccess = (data) => {
  return {
    type: TR_APPROVAL_REVIEW_COMPLETED_DATA_SUCCESS,
    data,
  };
};

// update TR approval stickers
export const updateTrApprovalStickerData = (scenarioId, data, type, formData) => {
  return (dispatch) => {
    dispatch(fetchStart());
    updateTrApprovalStickerDataApi(scenarioId, data, type)
      .then((response) => {
        dispatch(fetchEnd());
        if (formData) {
          dispatch(getTRApprovalReviewData(formData));
        }
        toast.success(response.data.response);
      })
      .catch((error) => {
        dispatch(fetchEnd());
        //toast.error(error.response.data.error.message);
      });
  };
};

const updateTrApprovalStickerDataApi = (scenarioId, data, type) => {
  const headers = {
    Authorization: secureLocalStorage.getItem('aTk'),
  };
  var result;
  if (type === 'mass') {
    result = axios.put('promotion/tr-mass-approval/' + scenarioId + '?country=' + data.country, {
      headers: headers,
    });
  }
  else {
    result = axios.put('update-tr-approval?scenario_id=' + scenarioId, data, {
      headers: headers,
    });
  }
  return result;
};
//custom groups in grid
export const getGroupedCustomGroups = (data) => {
  return (dispatch) => {
    getGroupedCustomGroupsApi(data)
      .then((response) => {
        dispatch(getGroupedCustomGroupsSuccess(response.data.response));
      })
      .catch((error) => { });
  };
};
const getGroupedCustomGroupsApi = (data) => {
  const headers = {
    Authorization: secureLocalStorage.getItem('aTk'),
  };
  var result;
  result = axios.post('promotion/custom-grouped-data', data, {
    headers: headers,
  });
  return result;
};
export const getGroupedCustomGroupsSuccess = (data) => {
  return {
    type: GROUPED_CUSTOM_GROUP,
    data,
  };
};
//upload Costing file download after Comparison

export const uploadCostingAfterComparisonDataFile = (
  scenarioNumber,
  isDownload,
  file,
  name,
) => {
  return (dispatch) => {
    dispatch(fetchStart());
    uploadCostingAfterComparisonDataFileApi(
      scenarioNumber,
      isDownload,
      file,
      name,
    )
      .then((response) => {
        if (isDownload) {
          dispatch(fetchEnd());
          toast('Please wait... The sheet is getting downloaded.');
          const downloadUrl = window.URL.createObjectURL(
            new Blob([response.data]),
          );
          const a = document.createElement('a');
          a.href = downloadUrl;
          a.setAttribute('download', `${name}_differences.xlsx`);
          document.body.appendChild(a);
          a.click();
          a.remove();
          window.URL.revokeObjectURL(downloadUrl);
        } else {
          dispatch(fetchEnd());
          dispatch(uploadCostingAfterComparisonSuccess(response.data.response));
        }
      })
      .catch((error) => {
        dispatch(fetchEnd());
        //toast.error(error.response.data.complete_error_message);
      });
  };
};
const uploadCostingAfterComparisonDataFileApi = (
  scenarioNumber,
  isDownload,
  file,
) => {
  const headers = {
    Authorization: secureLocalStorage.getItem('aTk'),
    'Content-Type': 'multipart/form-data;',
  };
  var result;
  if (isDownload) {
    result = axios.post(
      'promotion/download-compare-data?scenario_number=' +
      scenarioNumber +
      '&download=' +
      isDownload,
      file,
      {
        headers: headers,
        responseType: 'blob',
      },
    );
  } else {
    result = axios.post(
      'promotion/download-compare-data?scenario_number=' +
      scenarioNumber +
      '&download=' +
      isDownload,
      file,
      {
        headers: headers,
      },
    );
  }
  return result;
};

export const uploadCostingAfterComparisonSuccess = (data) => {
  return {
    type: PROMOTION_COSTING_COMPARISON_UPLOAD_SUCCESS,
    data,
  };
};

// //   get dropdown data for file download
export const getDropdownScenarioData = () => {
  return (dispatch) => {
    dispatch(fetchStart());
    getDropdownScenarioDataApi()
      .then((response) => {
        dispatch(fetchEnd());
        dispatch(getDropdownScenarioDataSuccess(response.data.response));
      })
      .catch((error) => {
        dispatch(fetchEnd());
      });
  };
};

const getDropdownScenarioDataApi = () => {
  const headers = {
    Authorization: secureLocalStorage.getItem('aTk'),
  };
  var result;
  result = axios.get('promotion/costing-scenarios', {
    headers: headers,
  });
  return result;
};

export const getDropdownScenarioDataSuccess = (data) => {
  return {
    type: PROMO_COSTING_DROPDOWN_DATA_SUCCESS,
    data,
  };
};

//approve scenario
// Returns the promise (true on success) so the caller can wait for the status update before reloading
export const approveScenario = (id, status, comments) => {
  return (dispatch) => {
    dispatch(fetchStart());
    return approveScenarioApi(id, status, comments)
      .then((response) => {
        dispatch(fetchEnd());
        toast.success(response.data.response);
        return true;
      })
      .catch((error) => {
        dispatch(fetchEnd());
        return false;
      });
  };
};

const approveScenarioApi = (id, status, comments) => {
  const headers = {
    Authorization: secureLocalStorage.getItem('aTk'),
  };
  var result;

  result = axios.put(
    'promotion/' + id + '/update-status/' + status,
    { comments: comments },
    { headers: headers }
  );
  return result;
};

//   get table data for costing
export const getCostingTableData = (data) => {
  return (dispatch) => {
    dispatch(fetchStart());
    dispatch(getCostingTableDataSuccess(null, true));
    getCostingTableDataApi(data)
      .then((response) => {
        dispatch(fetchEnd());
        dispatch(getCostingTableDataSuccess(response.data.response, false));
      })
      .catch((error) => {
        dispatch(fetchEnd());
        dispatch(getCostingTableDataSuccess(null, false));
      });
  };
};

const getCostingTableDataApi = (data) => {
  const headers = {
    Authorization: secureLocalStorage.getItem('aTk'),
  };
  var result;
  result = axios.get(
    'promotion-costing-approval?',
    { params: data, headers: headers },
  );
  return result;
};

export const getCostingTableDataSuccess = (data, loader) => {
  return {
    type: PROMO_COSTING_TABLE_DATA_SUCCESS,
    data,
    loader,
  };
};
//access grid
export const getAccessGrid = (data) => {
  return (dispatch) => {
    dispatch(getAccessGridData(null, true));
    getAccessGridAPI(data)
      .then((response) => {
        dispatch(getAccessGridData(response.data.response, false));
        if (response.data.response?.warning_message)
          toast.warning(response.data.response.warning_message)
      })
      .catch((error) => {
        dispatch(getAccessGridData(null, false));
      });
  };
};

const getAccessGridAPI = (data) => {
  const headers = {
    Authorization: secureLocalStorage.getItem('aTk'),
  };
  var result;
  result = axios.post('promotion/access-grid', data, { headers: headers });
  //}
  return result;
};

export const getAccessGridData = (data, loader) => {
  return {
    type: GRID_DATA,
    data,
    loader,
  };
};

// create/edit user access

export const createUserAccess = (data, type) => {
  return (dispatch) => {
    dispatch(fetchStart());
    createUserAccessAPI(data, type)
      .then((response) => {
        dispatch(fetchEnd());
        toast.success(response.data.response);
        if (type === 'promo_config') {
          dispatch(getUserAccess(null, type));
        }
        else {
          dispatch(getScenarioList(data.product_line));
          dispatch(getUserAccess(data.product_line));
        }
      })
      .catch((error) => {
        dispatch(fetchEnd());
      });
  };
};

const createUserAccessAPI = (data, type) => {
  const headers = {
    Authorization: secureLocalStorage.getItem('aTk'),
  };
  var result;
  if (type === 'promo_config')
    result = axios.post('promotion/user-access?is_configuration=true', data, { headers: headers });
  else
    result = axios.post('promotion/user-access', data, { headers: headers });
  return result;
};

//get user access data

export const getUserAccess = (productLine, type) => {
  return (dispatch) => {
    dispatch(fetchStart());
    getUserAccessApi(productLine, type)
      .then((response) => {
        dispatch(fetchEnd());
        dispatch(getUserAccessSuccess(response.data.response));
      })
      .catch((error) => {
        dispatch(fetchEnd());
      });
  };
};

const getUserAccessApi = (productLine, type) => {
  const headers = {
    Authorization: secureLocalStorage.getItem('aTk'),
  };
  var result;
  if (type === 'promo_config') {
    result = axios.get('promotion/user-access?is_configuration=true', {
      headers: headers,
    });
  }
  else
    result = axios.get('promotion/user-access?product_line=' + productLine, {
      headers: headers,
    });
  return result;
};

export const getUserAccessSuccess = (data) => {
  return {
    type: USER_ACCESS_DATA,
    data,
  };
};

// Create and Edit for promotion configuration model Year

export const createPromotionModelYear = (data) => {
  return (dispatch) => {
    dispatch(fetchStart());
    createPromotionModelYearAPI(data)
      .then((response) => {
        dispatch(fetchEnd());
        dispatch(fetchPromotionModelYear());
        toast.success(response.data.response);
      })
      .catch((error) => {
        dispatch(fetchEnd());
      });
  };
};

const createPromotionModelYearAPI = (data) => {
  const headers = {
    Authorization: secureLocalStorage.getItem('aTk'),
  };
  var result;
  result = axios.post('promotion/default', data, { headers: headers });
  return result;
};

// get promotion configuration model year

export const fetchPromotionModelYear = () => {
  return (dispatch) => {
    dispatch(fetchStart());
    fetchPromotionModelYearAPI()
      .then((response) => {
        dispatch(fetchEnd());
        dispatch(fetchPromotionModelYearSuccess(response.data.response));
      })
      .catch((error) => {
        dispatch(fetchEnd());
      });
  };
};

const fetchPromotionModelYearAPI = () => {
  const headers = {
    Authorization: secureLocalStorage.getItem('aTk'),
  };
  var result;
  result = axios.get(
    'promotion/default-all?key_name=promotion_configurations',
    { headers: headers },
  );
  return result;
};

export const fetchPromotionModelYearSuccess = (data) => {
  return {
    type: CURRENT_MODEL_YEAR,
    data,
  };
};

//   get data for finance costing dialog box
export const getFinanceCostingDialogData = (data) => {
  return (dispatch) => {
    dispatch(fetchStart());
    getFinanceCostingDialogDataApi(data)
      .then((response) => {
        dispatch(fetchEnd());
        dispatch(getFinanceCostingDialogDataSuccess(response.data.response));
      })
      .catch((error) => {
        dispatch(fetchEnd());
      });
  };
};

const getFinanceCostingDialogDataApi = (data) => {
  const headers = {
    Authorization: secureLocalStorage.getItem('aTk'),
  };
  var result;
  result = axios.post('promotion/review/markets', data, { headers: headers });
  return result;
};

export const getFinanceCostingDialogDataSuccess = (data) => {
  return {
    type: PROMO_FINANCE_COSTING_DIALOG_DATA_SUCCESS,
    data,
  };
};

//   get data for promotional offers
export const getFinancingOffersData = (data) => {
  return (dispatch) => {
    dispatch(fetchStart());
    getFinancingOffersDataApi(data)
      .then((response) => {
        dispatch(fetchEnd());
        dispatch(getPromotionalOffersDataSuccess(response.data.response));
      })
      .catch((error) => {
        dispatch(fetchEnd());
      });
  };
};

const getFinancingOffersDataApi = (data) => {
  const headers = {
    Authorization: secureLocalStorage.getItem('aTk'),
  };
  var result;
  result = axios.get(
    'promotion/promotional-financing?product_line=' +
    data.product_line +
    '&scenario_number=' +
    data.scenario_number,
    { headers: headers },
  );
  return result;
};

export const getPromotionalOffersDataSuccess = (data) => {
  return {
    type: PROMO_PROMOTIONAL_OFFERS_DATA_SUCCESS,
    data,
  };
};

//  get data for Regular Financing Offers

export const getRegularOffersData = () => {
  return (dispatch) => {
    dispatch(fetchStart());
    getRegularOffersDataApi()
      .then((response) => {
        dispatch(fetchEnd());
        dispatch(getRegularOffersDataSuccess(response.data.response));
      })
      .catch((error) => {
        dispatch(fetchEnd());
      });
  };
};
const getRegularOffersDataApi = () => {
  const headers = {
    Authorization: secureLocalStorage.getItem('aTk'),
  };
  var result;
  result = axios.get('promotion/regular-financing', { headers: headers });
  return result;
};

export const getRegularOffersDataSuccess = (data) => {
  return {
    type: PROMO_REGULAR_OFFERS_DATA_SUCCESS,
    data,
  };
};

//   get data for regular fianacing categorised
export const getRegularFinancingData = (data) => {
  return (dispatch) => {
    dispatch(fetchStart());
    getRegularFinancingDataApi(data)
      .then((response) => {
        dispatch(fetchEnd());
        dispatch(getRegularFinancingDataSuccess(response.data.response));
      })
      .catch((error) => {
        dispatch(fetchEnd());
      });
  };
};

const getRegularFinancingDataApi = (data) => {
  const headers = {
    Authorization: secureLocalStorage.getItem('aTk'),
  };
  var result;
  result = axios.get(
    'promotion/format-regular-financing?product_line=' + data.product_line,
    { headers: headers },
  );
  return result;
};

export const getRegularFinancingDataSuccess = (data) => {
  return {
    type: PROMO_REGULAR_FINANCING_DATA_SUCCESS,
    data,
  };
};

// delete

export const deleteRegularOffersData = (id) => {
  return (dispatch) => {
    deleteRegularOffersDataApi(id).then((response) => {
      toast.success(response.data.response);
      dispatch(getRegularOffersData());
    });
  };
};
const deleteRegularOffersDataApi = (id) => {
  const headers = {
    Authorization: secureLocalStorage.getItem('aTk'),
  };
  var result;
  result = axios.delete('promotion/regular-financing/' + id, {
    headers: headers,
  });
  return result;
};

// regular financing offers format
export const getRegularOffersFormatData = () => {
  return (dispatch) => {
    getRegularOffersFormatDataApi()
      .then((response) => {
        dispatch(getRegularOffersFormatDataSuccess(response.data.response));
      })
      .catch((error) => {
        //toast.error(error.response.data.error.message);
      });
  };
};

const getRegularOffersFormatDataApi = () => {
  const headers = {
    Authorization: secureLocalStorage.getItem('aTk'),
  };
  var result;
  result = axios.get(
    'upload-format?app-functionality=PromotionRegularFinancingsFormat',
    { headers: headers },
  );
  return result;
};

export const getRegularOffersFormatDataSuccess = (data) => {
  return {
    type: PROMO_REGULAR_OFFERS_FORMAT_SUCCESS,
    data,
  };
};

// delete Regular Financing format
export const deleteRegularOffersFormatData = (id) => {
  return (dispatch) => {
    dispatch(fetchStart());
    deleteRegularOffersFormatDataApi(id)
      .then((response) => {
        dispatch(fetchEnd());
        if (response.status === 201 || response.status === 200) {
          toast.success(response.data.response);
          dispatch(getRegularOffersFormatData());
        } else {
          //toast.error(response.data.error.message);
        }
      })
      .catch((error) => {
        dispatch(fetchEnd());
        //toast.error(error.response.data.error.message);
      });
  };
};

const deleteRegularOffersFormatDataApi = (id) => {
  const headers = {
    Authorization: secureLocalStorage.getItem('aTk'),
  };
  var result;
  result = axios.delete('upload-format/' + id, { headers: headers });
  return result;
};

//upload
export const uploadRegularOffersDataFile = (id, file) => {
  return (dispatch) => {
    dispatch(fetchStart());
    uploadRegularOffersDataFileApi(id, file)
      .then((response) => {
        if (response.status === 201 || response.status === 200) {
          dispatch(fetchEnd());
          dispatch(uploadRegularOffersSuccess(response.data.response));
          if (
            response.data.response &&
            response.data.response.error_list == null
          ) {
            toast.success(response.data.response.success_msg);
          }
        } else {
          //toast.error(response.data.complete_error_message);
        }
      })
      .catch((error) => {
        dispatch(fetchEnd());
        //toast.error(error.response.data.complete_error_message);
      });
  };
};
const uploadRegularOffersDataFileApi = (id, file) => {
  const headers = {
    Authorization: secureLocalStorage.getItem('aTk'),
    'Content-Type': 'multipart/form-data;',
  };
  var result;
  result = axios.post('upload-file?format_id=' + id, file, {
    headers: headers,
  });
  return result;
};
export const uploadRegularOffersSuccess = (data) => {
  return {
    type: PROMO_REGULAR_OFFERS_UPLOAD_SUCCESS,
    data,
  };
};

//get regular financing offers format fields
export const getRegularOffersFormatFields = () => {
  return (dispatch) => {
    getRegularOffersFormatFieldsApi()
      .then((response) => {
        dispatch(getRegularOffersFormatFieldsSuccess(response.data.response));
      })
      .catch((error) => {
        //toast.error(error.response.data.error.message);
      });
  };
};

const getRegularOffersFormatFieldsApi = () => {
  const headers = {
    Authorization: secureLocalStorage.getItem('aTk'),
  };
  var result;
  result = axios.get(
    'upload-format-fields?app-functionality=PromotionRegularFinancingsFormat',
    { headers: headers },
  );
  return result;
};

export const getRegularOffersFormatFieldsSuccess = (data) => {
  return {
    type: PROMO_REGULAR_OFFERS_FIELDS_SUCCESS,
    data,
  };
};

//add regular finance format
export const addRegularOffersFormatData = (data) => {
  return (dispatch) => {
    dispatch(fetchStart());
    addRegularOffersFormatDataApi(data)
      .then((response) => {
        toast.success(response.data.response);
        dispatch(fetchEnd());
        history.push('/regular-offers/regular-offers-excel-upload');
      })
      .catch((error) => {
        dispatch(fetchEnd());
        //toast.error(error.response.data.error.message);
      });
  };
};

const addRegularOffersFormatDataApi = (data) => {
  const headers = {
    Authorization: secureLocalStorage.getItem('aTk'),
  };
  var result;
  result = axios.post(
    'upload-format?app-functionality=PromotionRegularFinancingsFormat',
    data,
    { headers: headers },
  );
  return result;
};

// update regular financing offers format
export const updateRegularOffersFormatData = (id, data) => {
  return (dispatch) => {
    dispatch(fetchStart());
    updateRegularOffersFormatDataApi(id, data)
      .then((response) => {
        dispatch(fetchEnd());
        if (response.status === 201 || response.status === 200) {
          toast.success(response.data.response);
          history.push('/regular-offers/regular-offers-excel-upload');
        } else {
          //toast.error(response.data.error.message);
        }
      })
      .catch((error) => {
        dispatch(fetchEnd());
        //toast.error(error.response.data.error.message);
      });
  };
};

const updateRegularOffersFormatDataApi = (id, data) => {
  const headers = {
    Authorization: secureLocalStorage.getItem('aTk'),
  };
  var result;
  result = axios.put(
    'upload-format/' +
    id +
    '?app-functionality=PromotionRegularFinancingsFormat',
    data,
    { headers: headers },
  );
  return result;
};

export const downloadVistex = (data, name) => {
  return (dispatch) => {
    toast.info(
      'Downloading has been started in background. File will be downloaded automatically once ready.',
    );
    dispatch(downloading(true));
    downloadVistexApi(data)
      .then((response) => {
        dispatch(downloading(false));
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', name + '.xlsx');
        document.body.appendChild(link);
        link.click();
      })
      .catch((error) => {
        dispatch(downloading(false));
      });
  };
};

const downloadVistexApi = (data) => {
  const headers = {
    'Content-Type': 'application/xlsx',
    Authorization: secureLocalStorage.getItem('aTk'),
  };
  var result;
  result = axios.post('promotion/vistex-download', data, {
    headers: headers,
    responseType: 'blob',
  });
  return result;
};
export const downloading = (data) => {
  return {
    type: DOWNLOADING,
    data,
  };
};
//for duplicate validation
export const getValidMarkets = (id) => {
  return (dispatch) => {
    getValidMarketsApi(id).then((response) => {
      dispatch(getValidMarketsSuccess(response.data.response));
    });
  };
};

const getValidMarketsApi = (id) => {
  const headers = {
    Authorization: secureLocalStorage.getItem('aTk'),
  };
  var result;
  result = axios.get('promotion/scenario/grids/' + id, { headers: headers });
  return result;
};

export const getValidMarketsSuccess = (data) => {
  return {
    type: VALID_MARKETS,
    data,
  };
};

//   get data for comment dialog box
export const getCommentDialogData = (data) => {
  return (dispatch) => {
    dispatch(fetchStart());
    getCommentDialogDataApi(data)
      .then((response) => {
        dispatch(fetchEnd());
        dispatch(getCommentDialogDataSuccess(response.data.response));
      })
      .catch((error) => {
        dispatch(fetchEnd());
      });
  };
};

const getCommentDialogDataApi = (data) => {
  const headers = {
    Authorization: secureLocalStorage.getItem('aTk'),
  };
  var result;
  result = axios.post('promotion/comments-retrieve', data, { headers: headers });
  return result;
};

export const getCommentDialogDataSuccess = (data) => {
  return {
    type: PROMO_COMMENT_DIALOG_DATA_SUCCESS,
    data,
  };
};

//save data for comment dialog box

export const saveCommentDialogData = (data) => {
  return (dispatch) => {
    dispatch(fetchStart());
    saveCommentDialogDataAPI(data)
      .then((response) => {
        delete data.comments
        dispatch(fetchEnd());
        dispatch(getCommentDialogData(data))
      })
      .catch((error) => {
        dispatch(fetchEnd());
      });
  };
};

const saveCommentDialogDataAPI = (data) => {
  const headers = {
    Authorization: secureLocalStorage.getItem('aTk'),
  };
  var result;
  result = axios.post('promotion/comments-save', data, { headers: headers });
  return result;
};

//get scenario-level approval comments
// API groups them by team ([{ team, comments: [...] }]); each comment carries its own team, so the
// list is flattened for the caller. Resolves to null on failure.
export const getScenarioComments = (scenarioNumber) => {
  return (dispatch) => {
    dispatch(fetchStart());
    return getScenarioCommentsApi(scenarioNumber)
      .then((response) => {
        dispatch(fetchEnd());
        return (response.data.response || []).flatMap((group) => group.comments || []);
      })
      .catch((error) => {
        dispatch(fetchEnd());
        return null;
      });
  };
};

const getScenarioCommentsApi = (scenarioNumber) => {
  const headers = {
    Authorization: secureLocalStorage.getItem('aTk'),
  };
  var result;
  result = axios.get('promotion/' + scenarioNumber + '/approval-comments', { headers: headers });
  return result;
};

//save scenario-level approval comment (Business / Finance team)
// Returns the promise so the caller can update its view once the comment is created
export const saveScenarioComment = (data) => {
  return (dispatch) => {
    dispatch(fetchStart());
    return saveScenarioCommentApi(data)
      .then((response) => {
        dispatch(fetchEnd());
        toast.success(response.data.response);
        return true;
      })
      .catch((error) => {
        // Error toast comes from the axios interceptor
        dispatch(fetchEnd());
        return false;
      });
  };
};

const saveScenarioCommentApi = (data) => {
  const headers = {
    Authorization: secureLocalStorage.getItem('aTk'),
  };
  var result;
  result = axios.post('promotion/approval-comment', data, { headers: headers });
  return result;
};

//delete scenario-level approval comment
// Returns the promise so the caller can reload the comments once it is deleted
export const deleteScenarioComment = (id) => {
  return (dispatch) => {
    dispatch(fetchStart());
    return deleteScenarioCommentApi(id)
      .then((response) => {
        dispatch(fetchEnd());
        toast.success(response.data.response);
        return true;
      })
      .catch((error) => {
        // Error toast comes from the axios interceptor
        dispatch(fetchEnd());
        return false;
      });
  };
};

const deleteScenarioCommentApi = (id) => {
  const headers = {
    Authorization: secureLocalStorage.getItem('aTk'),
  };
  var result;
  result = axios.delete('promotion/approval-comments/' + id, { headers: headers });
  return result;
};

//replace sticker

export const replaceSticker = (data, scenarioIDs) => {
  return (dispatch) => {
    dispatch(fetchStart());
    replaceStickerAPI(data)
      .then((response) => {
        dispatch(fetchEnd());
        toast.success(response.data.response);
        dispatch(PromotionScenario({ scenario_ids: scenarioIDs }, null, 'fetch_id'));
      })
      .catch((error) => {
        dispatch(fetchEnd());
      });
  };
};

const replaceStickerAPI = (data) => {
  const headers = {
    Authorization: secureLocalStorage.getItem('aTk'),
  };
  var result;
  result = axios.post('promotion/scenario/replace-sticker', data, { headers: headers });
  return result;
};

// History upload data  
export const uploadHistoryUploadFile = (id, file) => {
  return (dispatch) => {
    dispatch(fetchStart());
    uploadHistoryFileApi(id, file)
      .then((response) => {
        if (response.status === 201 || response.status === 200) {
          dispatch(fetchEnd());
          dispatch(uploadHistoryUploadFileSuccess(response.data.response));
          if (
            response.data.response &&
            response.data.response.error_list == null
          ) {
            toast.success(response.data.response.success_msg);
          }
        } else {
          dispatch(fetchEnd());
          //toast.error(response.data.complete_error_message);
        }
      })
      .catch((error) => {
        dispatch(fetchEnd());
        //toast.error(error.response.data.complete_error_message);
      });
  };
};
const uploadHistoryFileApi = (id, file) => {
  const headers = {
    Authorization: secureLocalStorage.getItem('aTk'),
    'Content-Type': 'multipart/form-data;',
  };
  var result;
  result = axios.post('/upload-file?format_id=' + id, file, {
    headers: headers,
  });
  return result;
};
export const uploadHistoryUploadFileSuccess = (data) => {
  return {
    type: HISTORY_UPLOAD_SUCCESS,
    data,
  };
};

// Manual promotion GEt data

export const getManaualPromotionMaintenanceDetails = () => {
  return (dispatch) => {
    dispatch(fetchStart());
    getManaualPromotionMaintenanceDetailsApi().then((response) => {
      dispatch(getManaualPromotionMaintenanceDetailsSuccess(response.data.response));
      dispatch(fetchEnd());
    })
      .catch((error) => {
        dispatch(fetchEnd());
      })
  };
};
const getManaualPromotionMaintenanceDetailsApi = () => {
  const headers = {
    Authorization: secureLocalStorage.getItem('aTk'),
  };
  var result;
  result = axios.get(
    `promotion/manual-scenarios`,
    { headers: headers },
  );
  return result;
};
export const getManaualPromotionMaintenanceDetailsSuccess = (data) => {
  return {
    type: MANUAL_PROMO_SUCCESS,
    data,
  };
};


// Manual Promotion format feilds

export const getManualPromoFormatFeilds = () => {
  return (dispatch) => {
    getManualPromoFormatFeildsApi()
      .then((response) => {
        dispatch(getManualPromoFormatFeildsSuccess(response.data.response));
      })
      .catch((error) => {
        //toast.error(error.response.data.error.message);
      });
  };
};

const getManualPromoFormatFeildsApi = () => {
  const headers = {
    Authorization: secureLocalStorage.getItem('aTk'),
  };
  var result;
  result = axios.get(
    '/upload-format-fields?app-functionality=PromotionManualScenariosFormat',
    { headers: headers },
  );
  return result;
};
export const getManualPromoFormatFeildsSuccess = (data) => {
  return {
    type: MANUAL_FIELD_SUCCESS,
    data,
  };
};


// post for create format

export const addManualPromoFormatData = (data) => {
  return (dispatch) => {
    dispatch(fetchStart());
    addManualPromoFormatDataApi(data)
      .then((response) => {
        dispatch(fetchEnd());
        toast.success(response.data.response);
        history.push('/manual-promo-maintenance/upload-manual-promo');
      })
      .catch((error) => {
        dispatch(fetchEnd());
        //toast.error(error.response.data.error.message);
      });
  };
};
const addManualPromoFormatDataApi = (data) => {
  const headers = {
    Authorization: secureLocalStorage.getItem('aTk'),
  };
  var result;
  result = axios.post(
    'upload-format?app-functionality=PromotionManualScenariosFormat',
    data,
    { headers: headers },
  );
  return result;
};

// get manual promo format data

export const getManualPromoFormatData = () => {
  return (dispatch) => {
    getManualPromoFormatDataApi()
      .then((response) => {
        dispatch(getManualPromoFormatDataSuccess(response.data.response));
      })
      .catch((error) => {
        //toast.error(error.response.data.error.message);
      });
  };
};
const getManualPromoFormatDataApi = () => {
  const headers = {
    Authorization: secureLocalStorage.getItem('aTk'),
  };
  var result;
  result = axios.get('/upload-format?app-functionality=PromotionManualScenariosFormat', {
    headers: headers,
  });
  return result;
};
export const getManualPromoFormatDataSuccess = (data) => {
  return {
    type: MANUAL_UPLOAD_FORMAT_DATA,
    data,
  };
};


export const updateOrDeleteManualPromoData = (id, data, methodType, pagination, limit) => {
  return (dispatch) => {
    updateOrDeleteManualPromoDataApi(id, data, methodType)
      .then((response) => {
        dispatch(updateOrDeleteManualPromoDataSuccess(response.data));

        toast.success(`Data ${methodType === 'PUT' ? 'updated' : 'deleted'} successfully`);


        dispatch(getManaualPromotionMaintenanceDetails(pagination, limit));
      })
      .catch((error) => {

        dispatch(fetchEnd());
      });
  };
};


const updateOrDeleteManualPromoDataApi = (id, data, methodType) => {
  const headers = {
    Authorization: secureLocalStorage.getItem('aTk'),
  };

  return axios({
    method: methodType,
    url: `/promotion/manual-scenarios/${id}`,
    data: methodType === 'PUT' ? data : {},
    headers,
  });
};

export const updateOrDeleteManualPromoDataSuccess = (response) => {
  return {
    type: MANUAL_UPLOAD_FORMAT_UPDATE_OR_DELETE,
    payload: response,
  };
};

// manual promo signle item edit 
export const updateManualPromoDataById = (data, id) => {
  return (dispatch) => {
    updateManualPromoDataApi(data, id)
      .then((response) => {
        toast.success(response.data.response);
        history.push('/manual-promo-maintenance');
      })
      .catch((error) => {
      });
  };
};

const updateManualPromoDataApi = (data, id) => {
  const headers = {
    Authorization: secureLocalStorage.getItem('aTk'),
  };
  var result;
  result = axios.put('/promotion/manual-scenarios/' + id, data, {
    headers: headers,
  });
  return result;
};


// get Manual promo data by ID

export const getManualPromoById = (id) => {
  return (dispatch) => {
    getManualPromoByIdApi(id)
      .then((response) => {
        dispatch(getManualPromoByIdSuccess(response.data.response));
      })

      .catch((error) => {
        //toast.error('Error');
      });
  };
};

const getManualPromoByIdApi = (id) => {
  const headers = {
    Authorization: secureLocalStorage.getItem('aTk'),
  };
  var result;
  result = axios.get('/promotion/manual-scenarios?id=' + id, { headers: headers });

  return result;
};

export const getManualPromoByIdSuccess = (data) => {
  return {
    type: MANUAL_PROMO_BY_ID,
    data,
  };
};


// delete manual promo format 
export const deleteManualPromoFormatData = (id) => {
  return (dispatch) => {
    dispatch(fetchStart());
    deleteManualPromoFormatDataApi(id)
      .then((response) => {
        dispatch(fetchEnd());

        toast.success(response.data.response);
        dispatch(getManualPromoFormatData());

      })
      .catch((error) => {
        dispatch(fetchEnd());
        //toast.error(error.response.data.error.message);
      });
  };
};

const deleteManualPromoFormatDataApi = (id) => {
  const headers = {
    Authorization: secureLocalStorage.getItem('aTk'),
  };
  var result;
  result = axios.delete('upload-format/' + id, { headers: headers });
  return result;
};

// update manual promo format

export const updatemanualPromoFormatData = (id, data) => {
  return (dispatch) => {
    dispatch(fetchStart());
    updatemanualPromoFormatDataApi(id, data)
      .then((response) => {
        dispatch(fetchEnd());
        if (response.status === 201 || response.status === 200) {
          toast.success(response.data.response);
          history.push('/manual-promo-maintenance/upload-manual-promo');
        } else {
          //toast.error(ServerError);
        }
      })
      .catch((error) => {
        dispatch(fetchEnd());
        //toast.error(ServerError);
      });
  };
};

const updatemanualPromoFormatDataApi = (id, data) => {
  const headers = {
    Authorization: secureLocalStorage.getItem('aTk'),
  };
  var result;
  result = axios.put(
    'upload-format/' + id + '?app-functionality=PromotionManualScenariosFormat',
    data,
    { headers: headers },
  );
  return result;
};

// get costing analysis data

export const getCostingAnalysisData = (id, type, MY) => {
  return (dispatch) => {
    dispatch(fetchStart());
    getCostingAnalysisDataApi(id, type, MY)
      .then((response) => {
        dispatch(fetchEnd());
        dispatch(getCostingAnalysisDataSuccess(response.data.response));
      })

      .catch((error) => {
        dispatch(fetchEnd());
      });
  };
};

const getCostingAnalysisDataApi = (id, type, MY) => {
  const headers = {
    Authorization: secureLocalStorage.getItem('aTk'),
  };
  var result;
  const isAllMY = MY === 'ALL';
  const isPromoType = type === 'promo-type';

  const baseUrl = isPromoType
    ? `promotion/get-report-by-scenario/${id}`
    : `promotion/costing-analyis/${type}?scenario_number=${id}`;

  const url = isAllMY
    ? `${baseUrl}${baseUrl.includes('?') ? '&' : '?'}all=true`
    : baseUrl;

  result = axios.get(url, { headers: headers });

  return result;
};

export const getCostingAnalysisDataSuccess = (data) => {
  return {
    type: PROMO_COSTING_ANALYSIS_DATA_SUCCESS,
    data,
  };
};

//get exception scenario by sticker id

export const getExceptionScenario = (data) => {
  return (dispatch) => {
    dispatch(fetchStart());
    getExceptionScenarioAPI(data)
      .then((response) => {
        dispatch(fetchEnd());
        dispatch(getExceptionScenarioSuccess(response.data.response));
      })
      .catch((error) => {
        dispatch(fetchEnd());
      });
  };
};

const getExceptionScenarioAPI = (data) => {
  const headers = {
    Authorization: secureLocalStorage.getItem('aTk'),
  };
  var result;
  result = axios.post('/promotion/stickers/scenarios', data, { headers: headers });
  return result;
};

export const getExceptionScenarioSuccess = (data) => {
  return {
    type: PROMO_FIN_EXCEPTION_SCENARIO_SUCCESS,
    data,
  };
};

// approve exception stickers

export const approveExceptionSticker = (data) => {
  return (dispatch) => {
    dispatch(fetchStart());
    approveExceptionStickerAPI(data)
      .then((response) => {
        dispatch(fetchEnd());
        toast.success(response.data.response)
        const savedItem = JSON.parse(sessionStorage.getItem('promoFinFilteredFields'));
        dispatch(runMultiPromoSearch(savedItem));
      })
      .catch((error) => {
        dispatch(fetchEnd());
      });
  };
};

const approveExceptionStickerAPI = (data) => {
  const headers = {
    Authorization: secureLocalStorage.getItem('aTk'),
  };
  var result;
  result = axios.put('/promotion/stickers/multi-promo-approval', data, { headers: headers });
  return result;
};

export const createPromoBudget = (data, id, type, mode, param) => {
  return (dispatch) => {
    dispatch(fetchStart());
    dispatch(getPromoBudgetData(null, true));
    return createPromoBudgetAPI(data, id, type, param)
      .then((response) => {
        dispatch(fetchEnd());
        if (type === 'create' || type === 'edit') {
          dispatch(getPromoBudgetData(response.data.data, false));
          if (response.data.response)
            toast.success(response.data.response);
          if (response.data.warning_message)
            toast.warning(response.data.warning_message);
          if (mode === 'save')
            history.push('/promotion-budget-dashboard');
        }
        else if (type === 'clone') {
          toast.success(response.data.response);
          if (mode === 'Archived') {
            dispatch(getBudgetList(data.product_line, {
              product_line: data.product_line,
              type: 'archive'
            }));
          }
          else
            dispatch(getBudgetList(data.product_line));
          dispatch(getPromoBudgetData(null, false));
        }
        else if (type === 'delete') {
          toast.success(response.data.response);
          dispatch(getBudgetList(data.product_line));
          dispatch(getPromoBudgetData(null, false));
        }
        else if (type === 'prefill') {
          dispatch(getPromoBudgetPrefillData(response.data.response, false));
        }
        else if (type === 'updatePlanName') {
          toast.success(response.data.response);
          dispatch(getBudgetList(mode));
          dispatch(getPromoBudgetData(null, false));
        }
        else if (id) {
          dispatch(getPromoBudgetData(response.data.response, false));
        }
        return response?.data;
      })
      .catch((error) => {
        // if (error?.response?.data?.complete_error_message)
        //   toast.error(error.response.data.complete_error_message)
        dispatch(getPromoBudgetData(null, false, true));
        dispatch(fetchEnd());
        throw error;
      });
  };
};

const createPromoBudgetAPI = (data, id, type, param) => {
  const headers = {
    Authorization: secureLocalStorage.getItem('aTk'),
  };
  var result;
  if (type === 'create' || type === 'edit' || type === 'updatePlanName')
    result = axios.post('promotion/budget-forecast', data, { headers: headers });
  else if (type === 'clone')
    result = axios.post('promotion/budget-forecast/' + id + '/clone', { headers: headers });
  else if (type === 'delete')
    result = axios.delete('promotion/budget-forecast/' + id, { headers: headers });
  else if (param)
    result = axios.get('promotion/budget-costing/' + id, { params: param, headers: headers });
  else if (id)
    result = axios.get('promotion/budget-costing/' + id, { headers: headers });
  return result;
};

export const getPromoBudgetData = (data, loader, error) => {
  return {
    type: PROMO_BUDGET_DATA_SUCCESS,
    data,
    loader,
    error,
  };
};

export const setTempPromoBudgetData = (data) => {
  return {
    type: TEMP_PROMO_BUDGET_DATA_SUCCESS,
    data,
  };
};

export const getPromoBudgetPrefillData = (data, loader) => {
  return {
    type: PROMO_BUDGET_PREFILL_DATA_SUCCESS,
    data,
    loader,
  };
};

export const clearPromoBudgetData = () => {
  return (dispatch) => {
    dispatch(getPromoBudgetData(null, false, false));
  };
};

//get budget list table data

export const getBudgetList = (productLine, data, type) => {
  return (dispatch) => {
    dispatch(fetchStart());
    getBudgetListApi(productLine, data, type)
      .then((response) => {
        dispatch(fetchEnd());
        if (type === 'prefill')
          dispatch(getBudgetPrefillListSuccess(response.data.response));
        else
          dispatch(getBudgetListSuccess(response.data.response));
      })
      .catch((error) => {
        dispatch(fetchEnd());
      });
  };
};
const getBudgetListApi = (productLine, data, type) => {
  const headers = {
    Authorization: secureLocalStorage.getItem('aTk'),
  };
  var result;
  if (data) {
    result = axios.get(
      'promotion/plan-list?',
      { params: data, headers: headers },
    );
  } else
    result = axios.get('promotion/plan-list?product_line=' + productLine, {
      headers: headers,
    });
  return result;
};

export const getBudgetListSuccess = (data) => {
  return {
    type: BUDGET_LIST_DATA_SUCCESS,
    data,
  };
};

export const getBudgetPrefillListSuccess = (data) => {
  return {
    type: BUDGET_PREFILL_LIST_DATA_SUCCESS,
    data,
  };
};

// get budget volume data
export const getBudgetVolumeData = (data) => {
  return (dispatch) => {
    dispatch(fetchStart());
    getBudgetVolumeDataApi(data)
      .then((response) => {
        dispatch(fetchEnd());
        dispatch(getBudgetVolumeDataSuccess(response.data.response));
      })
      .catch((error) => {
        dispatch(fetchEnd());
      });
  };
};
const getBudgetVolumeDataApi = (data) => {
  const headers = {
    Authorization: secureLocalStorage.getItem('aTk'),
  };
  var result;
  result = axios.post('promotion/budget/forecast-volume', data, { headers: headers });
  return result;
};

export const getBudgetVolumeDataSuccess = (data) => {
  return {
    type: BUDGET_VOLUME_DATA_SUCCESS,
    data,
  };
};

export const clearBudgetVolumeData = () => {
  return (dispatch) => {
    dispatch(getBudgetVolumeDataSuccess(null));
  };
};

// Get Budget Sales Forecast Data
export const getBudgetSalesForecastData = () => {
  return (dispatch) => {
    dispatch(fetchStart());
    getBudgetSalesForecastDataApi()
      .then((response) => {
        // Handle different response structures
        const data = response.data?.response || response.data || [];
        dispatch(fetchEnd());
        dispatch(getBudgetSalesForecastDataSuccess(data));
      })
      .catch((error) => {
        dispatch(fetchEnd());
      });
  };
};

const getBudgetSalesForecastDataApi = () => {
  const headers = {
    Authorization: secureLocalStorage.getItem('aTk'),
  };
  var result;
  result = axios.get('promotion/budget-sales-forecast', { headers: headers });
  return result;
};

export const getBudgetSalesForecastDataSuccess = (data) => {
  return {
    type: BUDGET_SALES_FORECAST_DATA_SUCCESS,
    data,
  };
};

// Delete Budget Sales Forecast Data
export const deleteBudgetSalesForecastData = (id) => {
  return (dispatch) => {
    dispatch(fetchStart());
    deleteBudgetSalesForecastDataApi(id)
      .then((response) => {
        dispatch(fetchEnd());
        toast.success(response.data.response);
        // Refresh the budget sales forecast data after deletion
        const formData = sessionStorage.getItem('search-data') ? JSON.parse(sessionStorage.getItem('search-data')) : {};
        dispatch(getPromotionsSearch(1, 0, 'search', formData, "promotion_budget_sales_forecast_data"));
      })
      .catch((error) => {
        dispatch(fetchEnd());
        // toast.error(error.response?.data?.response);
      });
  };
};

const deleteBudgetSalesForecastDataApi = (id) => {
  const headers = {
    Authorization: secureLocalStorage.getItem('aTk'),
  };
  var result;
  result = axios.delete('promotion/budget-sales-forecast/' + id, { headers: headers });
  return result;
};

// Get Single Budget Sales Forecast Data by ID
export const getSingleBudgetSalesForecastData = (id) => {
  return (dispatch) => {
    getSingleBudgetSalesForecastDataApi(id)
      .then((response) => {
        // Handle different response structures
        // API returns: { response: { ID, product_line, ... }, status: 200 }
        let data = response.data?.response || response.data || null;
        // If it's an array, take the first item
        if (Array.isArray(data) && data.length > 0) {
          data = data[0];
        }
        // Ensure we have valid data before dispatching
        if (data) {
          dispatch(getSingleBudgetSalesForecastDataSuccess(data));
        } else {
          console.error('No data received from API:', response);
        }
      })
      .catch((error) => {
        console.error('Error fetching budget sales forecast:', error);
      });
  };
};

const getSingleBudgetSalesForecastDataApi = (id) => {
  const headers = {
    Authorization: secureLocalStorage.getItem('aTk'),
  };
  var result;
  result = axios.get(`promotion/budget-sales-forecast?id=${id}`, { headers: headers });
  return result;
};

export const getSingleBudgetSalesForecastDataSuccess = (data) => {
  return {
    type: BUDGET_SALES_FORECAST_SINGLE_DATA_SUCCESS,
    data,
  };
};

// Update Budget Sales Forecast Data
export const updateBudgetSalesForecastData = (data, id) => {
  return (dispatch) => {
    dispatch(fetchStart());
    updateBudgetSalesForecastDataApi(data, id).then((response) => {
      dispatch(fetchEnd());
      toast.success(response.data.response);
      const formData = sessionStorage.getItem('search-data') ? JSON.parse(sessionStorage.getItem('search-data')) : {};
      dispatch(getPromotionsSearch(1, 0, 'search', formData, "promotion_budget_sales_forecast_data"));
      history.push({
        pathname: '/budget-forecast-main',
        state: 'BudgetSalesForecast',
      });
    })
      .catch((error) => {
        dispatch(fetchEnd());
      });
  };
};

const updateBudgetSalesForecastDataApi = (data, id) => {
  const headers = {
    Authorization: secureLocalStorage.getItem('aTk'),
  };
  var result;
  result = axios.put('promotion/budget-sales-forecast/' + id, data, { headers: headers });
  return result;
};

// Add Budget Sales Forecast Data
export const addBudgetSalesForecastData = (data) => {
  return (dispatch) => {
    addBudgetSalesForecastDataApi(data).then((response) => {
      toast.success(response.data.response);
      dispatch(getBudgetSalesForecastData());
      history.push('/budget-forecast-main');
    })
      .catch((error) => {
        // toast.error(error.response?.data?.response);
      });
  };
};

const addBudgetSalesForecastDataApi = (data) => {
  const headers = {
    Authorization: secureLocalStorage.getItem('aTk'),
  };
  var result;
  result = axios.post('promotion/budget-sales-forecast', data, { headers: headers });
  return result;
};

// update approval status
export const updateApprovalStatus = (id, tableName, type, data) => {
  return (dispatch) => {
    dispatch(fetchStart());
    updateApprovalStatusApi(id, tableName, type, data)
      .then((response) => {
        dispatch(fetchEnd());
        toast.success(response.data.response);
        if (tableName === 'promotion_budget_and_forecasts')
          dispatch(getBudgetList(data.product_line));
      })
      .catch((error) => {
        dispatch(fetchEnd());
      });
  };
};

const updateApprovalStatusApi = (id, tableName, type, data) => {
  const headers = {
    Authorization: secureLocalStorage.getItem('aTk'),
  };
  var result;
  result = axios.put(
    'promotion/' + id + '/' + type + '?table_name=' + tableName,
    {
      headers: headers,
    },
  );
  return result;
};


//get reporting and analytics table data

export const getBudgetReportingData = (data, type) => {
  return (dispatch) => {
    dispatch(fetchStart());
    getBudgetReportingDataApi(data, type)
      .then((response) => {
        dispatch(fetchEnd());
        dispatch(getBudgetReportingDataSuccess(response.data.response));
      })
      .catch((error) => {
        dispatch(fetchEnd());
      });
  };
};
const getBudgetReportingDataApi = (data, type) => {
  const headers = {
    Authorization: secureLocalStorage.getItem('aTk'),
  };
  var result;
  if (type === 'promotion-details') {
    result = axios.post(
      'promotion/budget/segment-stickers-quarterly',
      data,
      { headers: headers },
    );
  }
  else if (data) {
    result = axios.post(
      'promotion/budget-forecast/reporting',
      data,
      { headers: headers },
    );
  }
  return result;
};

export const getBudgetReportingDataSuccess = (data) => {
  return {
    type: BUDGET_REPORTING_DATA_SUCCESS,
    data,
  };
};

// budget promotions sticker details download
export const downloadBudgetStickersDetails = (data, name) => {
  return (dispatch) => {
    toast.info(
      'Downloading has been started in background. File will be downloaded automatically once ready.',
    );
    dispatch(downloading(true));
    downloadBudgetStickersDetailsApi(data)
      .then((response) => {
        dispatch(downloading(false));
        const fileName = `${name}_Promotion_Details.xlsx`;
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', fileName);
        document.body.appendChild(link);
        link.click();
      })
      .catch((error) => {
        dispatch(downloading(false));
      });
  };
};

const downloadBudgetStickersDetailsApi = (data) => {
  const headers = {
    'Content-Type': 'application/xlsx',
    Authorization: secureLocalStorage.getItem('aTk'),
  };
  var result;
  result = axios.post('promotion/budget-forecast/reporting/download', data, {
    headers: headers,
    responseType: 'blob',
  });
  return result;
};

// Get Approved Scenario Data for Budgeting Prefill
export const getApprovedScenarioList = (data) => {
  return (dispatch) => {
    dispatch(fetchStart());
    getApprovedScenarioListApi(data)
      .then((response) => {
        dispatch(fetchEnd());
        dispatch(getApprovedScenarioListSuccess(response.data.response));
      })
      .catch((error) => {
        dispatch(fetchEnd());
      });
  };
};

const getApprovedScenarioListApi = (data) => {
  const headers = {
    Authorization: secureLocalStorage.getItem('aTk'),
  };
  var result;
  if (data) {
    result = axios.get(
      '/promotion/budget-forecast/approved-scenarios', {
      params: data,
      headers: headers
    })
  }
  return result;
};

export const getApprovedScenarioListSuccess = (data) => {
  return {
    type: APPROVED_SCENARIO_LIST_SUCCESS,
    data,
  };
};

export const clearApprovedScenarioList = () => {
  return {
    type: APPROVED_SCENARIO_LIST_SUCCESS,
    data: [],
  };
};

// Prefill from approved scenario

export const prefillFromScenario = (data) => {
  return (dispatch) => {
    dispatch(fetchStart());
    dispatch(getPromoBudgetData(null, true));
    prefillFromScenarioAPI(data)
      .then((response) => {
        dispatch(fetchEnd());
        dispatch(getPromoBudgetData(response.data.data, false));
        if (response.data.response)
          toast.success(response.data.response);
        if (response.data.warning_message)
          toast.warning(response.data.warning_message);
      })
      .catch((error) => {
        dispatch(fetchEnd());
        dispatch(getPromoBudgetData(null, false, true));
      });
  };
};

const prefillFromScenarioAPI = (data) => {
  const headers = {
    Authorization: secureLocalStorage.getItem('aTk'),
  };
  var result;
  result = axios.post('/promotion/budget-forecast/prefill-from-scenario', data, { headers: headers });
  return result;
};

// Promo Signature Config
export const getPromoSignatureConfigList = (params) => {
  return (dispatch) => {
    dispatch(fetchStart());
    getPromoSignatureConfigListApi(params)
      .then((response) => {
        dispatch({ type: PROMO_SIGNATURE_CONFIG_LIST_SUCCESS, data: response.data.response });
        dispatch(fetchEnd());
      })
      .catch(() => {
        dispatch(fetchEnd());
      });
  };
};

const getPromoSignatureConfigListApi = (params) => {
  const headers = { Authorization: secureLocalStorage.getItem('aTk') };
  if (params)
    return axios.get('promotion/signature-config', { params, headers });
  else
    return axios.get('promotion/signature-config', { headers });
};

export const getPromoSignatureConfigById = (id) => {
  return (dispatch) => {
    dispatch(fetchStart());
    getPromoSignatureConfigByIdApi(id)
      .then((response) => {
        dispatch({ type: PROMO_SIGNATURE_CONFIG_BY_ID_SUCCESS, data: response.data.response });
        dispatch(fetchEnd());
      })
      .catch(() => {
        dispatch(fetchEnd());
      });
  };
};

const getPromoSignatureConfigByIdApi = (id) => {
  const headers = { Authorization: secureLocalStorage.getItem('aTk') };
  return axios.get(`promotion/signature-config/${id}`, { headers });
};

export const createPromoSignatureConfig = (data) => {
  return (dispatch) => {
    dispatch(fetchStart());
    axios.post('promotion/signature-config', data, { headers: { Authorization: secureLocalStorage.getItem('aTk') } })
      .then((response) => {
        dispatch(fetchEnd());
        toast.success(response.data.response);
        history.push('/promo-signature-config');
      })
      .catch(() => {
        dispatch(fetchEnd());
      });
  };
};

export const updatePromoSignatureConfig = (id, data, methodType) => {
  return (dispatch) => {
    dispatch(fetchStart());
    const headers = { Authorization: secureLocalStorage.getItem('aTk') };
    const request = methodType === 'DELETE'
      ? axios.delete(`promotion/signature-config/${id}`, { headers })
      : axios.put(`promotion/signature-config/${id}`, data, { headers });
    request
      .then((response) => {
        dispatch(fetchEnd());
        if (methodType === 'DELETE') {
          dispatch(getPromoSignatureConfigList());
        } else {
          toast.success(response.data.response);
          history.push('/promo-signature-config');
        }
      })
      .catch(() => {
        dispatch(fetchEnd());
      });
  };
};


//clone Prefill from approved scenario
export const cloneFromScenario = (id, data) => {
  return (dispatch) => {
    dispatch(fetchStart());
    cloneFromScenarioAPI(id)
      .then((response) => {
        dispatch(fetchEnd());
        dispatch(getBudgetList(data.product_line));
        if (response.data.response)
          toast.success(response.data.response);
        if (response.data.warning_message)
          toast.warning(response.data.warning_message);
      })
      .catch((error) => {
        dispatch(fetchEnd());
      });
  };
};

const cloneFromScenarioAPI = (id) => {
  const headers = {
    Authorization: secureLocalStorage.getItem('aTk'),
  };
  var result;
  result = axios.post('promotion/budget-forecast/' + id + '/clone-from-scenario', null, { headers });
  return result;
};

//get by id Prefill from approved scenario
export const getPrefillFromScenario = (id) => {
  return (dispatch) => {
    dispatch(fetchStart());
    getPrefillFromScenarioAPI(id)
      .then((response) => {
        dispatch(fetchEnd());
        dispatch(getPromoBudgetPrefillData(response.data.response, false));
        if (response.data.response)
          toast.success(response.data.response);
        if (response.data.warning_message)
          toast.warning(response.data.warning_message);
      })
      .catch((error) => {
        dispatch(fetchEnd());
      });
  };
};

const getPrefillFromScenarioAPI = (id) => {
  const headers = {
    Authorization: secureLocalStorage.getItem('aTk'),
  };
  var result;
  result = axios.get('promotion/budget-forecast/' + id + '/prefill-from-scenario', { headers: headers });
  return result;
};

// Promotions Material Master
export const getPromoMaterialMaster = (id) => {
  return (dispatch) => {
    dispatch(fetchStart());
    getPromoMaterialMasterApi(id)
      .then((response) => {
        dispatch({ type: PROMO_MATERIAL_MASTER_DETAIL_SUCCESS, data: response.data.response });
        dispatch(fetchEnd());
      })
      .catch(() => {
        dispatch(fetchEnd());
      });
  };
};

const getPromoMaterialMasterApi = (id) => {
  const headers = { Authorization: secureLocalStorage.getItem('aTk') };
  return axios.get(`promotion/material-master/${id}`, { headers });
};

// No id means add
export const savePromoMaterialMaster = (data, id) => {
  return (dispatch) => {
    dispatch(fetchStart());
    const headers = { Authorization: secureLocalStorage.getItem('aTk') };
    const request = id
      ? axios.put(`promotion/material-master/${id}`, data, { headers })
      : axios.post('promotion/material-master', data, { headers });
    request
      .then((response) => {
        dispatch(fetchEnd());
        toast.success(response.data.response);
        // Re-run the last search; it also navigates back to the list
        dispatch(
          getPromotionsSearch(
            1,
            0,
            'search',
            JSON.parse(sessionStorage.getItem('search-data')),
            'promotion_material_master',
          ),
        );
      })
      .catch(() => {
        dispatch(fetchEnd());
      });
  };
};

export const deletePromoMaterialMaster = (id) => {
  return (dispatch) => {
    dispatch(fetchStart());
    const headers = { Authorization: secureLocalStorage.getItem('aTk') };
    const data = {
      table_name: 'promotion_material_master',
      filter_fields: {
        id: { filter_name: 'id', filter_option: 'equal', filter_value: id },
      },
    };
    axios.post('generic-delete', data, { headers })
      .then((response) => {
        dispatch(fetchEnd());
        toast.success(response.data.response);
        // Re-run the last search so the list reflects the delete
        dispatch(
          getPromotionsSearch(
            1,
            0,
            'search',
            JSON.parse(sessionStorage.getItem('search-data')),
            'promotion_material_master',
          ),
        );
      })
      .catch(() => {
        dispatch(fetchEnd());
      });
  };
};
